// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "./types.js";

export const MODELS = {
	"amazon-bedrock": {
		"amazon.nova-2-lite-v1:0": {
			id: "amazon.nova-2-lite-v1:0",
			name: "Nova 2 Lite",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.33,
				output: 2.75,
				cacheRead: 0.0825,
				cacheWrite: 0.33,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"bedrock-converse-stream">,
		"amazon.nova-lite-v1:0": {
			id: "amazon.nova-lite-v1:0",
			name: "Nova Lite",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.06,
				output: 0.24,
				cacheRead: 0.015,
				cacheWrite: 0.06,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"amazon.nova-micro-v1:0": {
			id: "amazon.nova-micro-v1:0",
			name: "Nova Micro",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.035,
				output: 0.14,
				cacheRead: 0.00875,
				cacheWrite: 0.035,
			},
			contextWindow: 128000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"amazon.nova-pro-v1:0": {
			id: "amazon.nova-pro-v1:0",
			name: "Nova Pro",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.8,
				output: 3.2,
				cacheRead: 0.2,
				cacheWrite: 0.8,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-fable-5": {
			id: "anthropic.claude-fable-5",
			name: "Claude Fable 5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-fable-5-1": {
			id: "anthropic.claude-fable-5-1",
			name: "Claude Fable 5.1",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.1,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-haiku-5-5": {
			id: "anthropic.claude-haiku-5-5",
			name: "Claude Haiku 5.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-4-1-20250805-v1:0": {
			id: "anthropic.claude-opus-4-1-20250805-v1:0",
			name: "Claude Opus 4.1",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 75,
				cacheRead: 1.5,
				cacheWrite: 18.75,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-4-5-20251101-v1:0": {
			id: "anthropic.claude-opus-4-5-20251101-v1:0",
			name: "Claude Opus 4.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-4-6-v1": {
			id: "anthropic.claude-opus-4-6-v1",
			name: "Claude Opus 4.6",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-4-7": {
			id: "anthropic.claude-opus-4-7",
			name: "Claude Opus 4.7",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-4-8": {
			id: "anthropic.claude-opus-4-8",
			name: "Claude Opus 4.8",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-5": {
			id: "anthropic.claude-opus-5",
			name: "Claude Opus 5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-opus-5-5": {
			id: "anthropic.claude-opus-5-5",
			name: "Claude Opus 5.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.2,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-sonnet-4-5-20250929-v1:0": {
			id: "anthropic.claude-sonnet-4-5-20250929-v1:0",
			name: "Claude Sonnet 4.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-sonnet-4-6": {
			id: "anthropic.claude-sonnet-4-6",
			name: "Claude Sonnet 4.6",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-sonnet-5": {
			id: "anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"anthropic.claude-sonnet-5-5": {
			id: "anthropic.claude-sonnet-5-5",
			name: "Claude Sonnet 5.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"apac.amazon.nova-lite-v1:0": {
			id: "apac.amazon.nova-lite-v1:0",
			name: "Nova Lite (APAC)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.063,
				output: 0.252,
				cacheRead: 0.01575,
				cacheWrite: 0.063,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"apac.amazon.nova-micro-v1:0": {
			id: "apac.amazon.nova-micro-v1:0",
			name: "Nova Micro (APAC)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.037,
				output: 0.148,
				cacheRead: 0.00925,
				cacheWrite: 0.037,
			},
			contextWindow: 128000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"apac.amazon.nova-pro-v1:0": {
			id: "apac.amazon.nova-pro-v1:0",
			name: "Nova Pro (APAC)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.84,
				output: 3.36,
				cacheRead: 0.21,
				cacheWrite: 0.84,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"apac.anthropic.claude-sonnet-4-20250514-v1:0": {
			id: "apac.anthropic.claude-sonnet-4-20250514-v1:0",
			name: "Claude Sonnet 4 (APAC)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "au.anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 5.5,
				cacheRead: 0.11,
				cacheWrite: 1.375,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-haiku-5-5": {
			id: "au.anthropic.claude-haiku-5-5",
			name: "Claude Haiku 5.5 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.11,
				output: 0.55,
				cacheRead: 0.011,
				cacheWrite: 0.1375,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-opus-4-6-v1": {
			id: "au.anthropic.claude-opus-4-6-v1",
			name: "AU Anthropic Claude Opus 4.6",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-opus-4-7": {
			id: "au.anthropic.claude-opus-4-7",
			name: "Claude Opus 4.7 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-opus-4-8": {
			id: "au.anthropic.claude-opus-4-8",
			name: "Claude Opus 4.8 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-opus-5": {
			id: "au.anthropic.claude-opus-5",
			name: "Claude Opus 5 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-opus-5-5": {
			id: "au.anthropic.claude-opus-5-5",
			name: "Claude Opus 5.5 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.4,
				output: 22,
				cacheRead: 0.22,
				cacheWrite: 5.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-sonnet-4-5-20250929-v1:0": {
			id: "au.anthropic.claude-sonnet-4-5-20250929-v1:0",
			name: "Claude Sonnet 4.5 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-sonnet-4-6": {
			id: "au.anthropic.claude-sonnet-4-6",
			name: "AU Anthropic Claude Sonnet 4.6",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"au.anthropic.claude-sonnet-5": {
			id: "au.anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5 (AU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"ca.amazon.nova-lite-v1:0": {
			id: "ca.amazon.nova-lite-v1:0",
			name: "Nova Lite (CA)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.064,
				output: 0.256,
				cacheRead: 0.016,
				cacheWrite: 0.064,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"deepseek.v3-v1:0": {
			id: "deepseek.v3-v1:0",
			name: "DeepSeek-V3.1",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.58,
				output: 1.68,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 81920,
		} satisfies Model<"bedrock-converse-stream">,
		"deepseek.v3.2": {
			id: "deepseek.v3.2",
			name: "DeepSeek V3.2",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.62,
				output: 1.85,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 81920,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.amazon.nova-2-lite-v1:0": {
			id: "eu.amazon.nova-2-lite-v1:0",
			name: "Nova 2 Lite (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.374,
				output: 3.157,
				cacheRead: 0.0935,
				cacheWrite: 0.374,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.amazon.nova-lite-v1:0": {
			id: "eu.amazon.nova-lite-v1:0",
			name: "Nova Lite (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.069,
				output: 0.276,
				cacheRead: 0.01725,
				cacheWrite: 0.069,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.amazon.nova-micro-v1:0": {
			id: "eu.amazon.nova-micro-v1:0",
			name: "Nova Micro (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.04,
				output: 0.16,
				cacheRead: 0.01,
				cacheWrite: 0.04,
			},
			contextWindow: 128000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.amazon.nova-pro-v1:0": {
			id: "eu.amazon.nova-pro-v1:0",
			name: "Nova Pro (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.92,
				output: 3.68,
				cacheRead: 0.23,
				cacheWrite: 0.92,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-fable-5": {
			id: "eu.anthropic.claude-fable-5",
			name: "Claude Fable 5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 11,
				output: 55,
				cacheRead: 1.1,
				cacheWrite: 13.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "eu.anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 5.5,
				cacheRead: 0.11,
				cacheWrite: 1.375,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-haiku-5-5": {
			id: "eu.anthropic.claude-haiku-5-5",
			name: "Claude Haiku 5.5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.11,
				output: 0.55,
				cacheRead: 0.011,
				cacheWrite: 0.1375,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-opus-4-5-20251101-v1:0": {
			id: "eu.anthropic.claude-opus-4-5-20251101-v1:0",
			name: "Claude Opus 4.5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-opus-4-6-v1": {
			id: "eu.anthropic.claude-opus-4-6-v1",
			name: "Claude Opus 4.6 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-opus-4-7": {
			id: "eu.anthropic.claude-opus-4-7",
			name: "Claude Opus 4.7 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-opus-4-8": {
			id: "eu.anthropic.claude-opus-4-8",
			name: "Claude Opus 4.8 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-opus-5": {
			id: "eu.anthropic.claude-opus-5",
			name: "Claude Opus 5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-opus-5-5": {
			id: "eu.anthropic.claude-opus-5-5",
			name: "Claude Opus 5.5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.4,
				output: 22,
				cacheRead: 0.22,
				cacheWrite: 5.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-sonnet-4-20250514-v1:0": {
			id: "eu.anthropic.claude-sonnet-4-20250514-v1:0",
			name: "Claude Sonnet 4 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-sonnet-4-5-20250929-v1:0": {
			id: "eu.anthropic.claude-sonnet-4-5-20250929-v1:0",
			name: "Claude Sonnet 4.5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-sonnet-4-6": {
			id: "eu.anthropic.claude-sonnet-4-6",
			name: "Claude Sonnet 4.6 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-sonnet-5": {
			id: "eu.anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.anthropic.claude-sonnet-5-5": {
			id: "eu.anthropic.claude-sonnet-5-5",
			name: "Claude Sonnet 5.5 (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.11,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"eu.mistral.pixtral-large-2502-v1:0": {
			id: "eu.mistral.pixtral-large-2502-v1:0",
			name: "Pixtral Large (25.02) (EU)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"global.amazon.nova-2-lite-v1:0": {
			id: "global.amazon.nova-2-lite-v1:0",
			name: "Nova 2 Lite (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.075,
				cacheWrite: 0.3,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-fable-5": {
			id: "global.anthropic.claude-fable-5",
			name: "Claude Fable 5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-fable-5-1": {
			id: "global.anthropic.claude-fable-5-1",
			name: "Claude Fable 5.1 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "global.anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.1,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-haiku-5-5": {
			id: "global.anthropic.claude-haiku-5-5",
			name: "Claude Haiku 5.5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-opus-4-5-20251101-v1:0": {
			id: "global.anthropic.claude-opus-4-5-20251101-v1:0",
			name: "Claude Opus 4.5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-opus-4-6-v1": {
			id: "global.anthropic.claude-opus-4-6-v1",
			name: "Claude Opus 4.6 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-opus-4-7": {
			id: "global.anthropic.claude-opus-4-7",
			name: "Claude Opus 4.7 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-opus-4-8": {
			id: "global.anthropic.claude-opus-4-8",
			name: "Claude Opus 4.8 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-opus-5": {
			id: "global.anthropic.claude-opus-5",
			name: "Claude Opus 5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-opus-5-5": {
			id: "global.anthropic.claude-opus-5-5",
			name: "Claude Opus 5.5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.2,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-sonnet-4-20250514-v1:0": {
			id: "global.anthropic.claude-sonnet-4-20250514-v1:0",
			name: "Claude Sonnet 4 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-sonnet-4-5-20250929-v1:0": {
			id: "global.anthropic.claude-sonnet-4-5-20250929-v1:0",
			name: "Claude Sonnet 4.5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-sonnet-4-6": {
			id: "global.anthropic.claude-sonnet-4-6",
			name: "Claude Sonnet 4.6 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-sonnet-5": {
			id: "global.anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.anthropic.claude-sonnet-5-5": {
			id: "global.anthropic.claude-sonnet-5-5",
			name: "Claude Sonnet 5.5 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.moonshotai.kimi-k3": {
			id: "global.moonshotai.kimi-k3",
			name: "Kimi K3 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1048576,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-5.6-luna": {
			id: "global.openai.gpt-5.6-luna",
			name: "GPT-5.6 Luna (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-5.6-sol": {
			id: "global.openai.gpt-5.6-sol",
			name: "GPT-5.6 Sol (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-5.6-terra": {
			id: "global.openai.gpt-5.6-terra",
			name: "GPT-5.6 Terra (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-6-astra": {
			id: "global.openai.gpt-6-astra",
			name: "GPT-6 Astra (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-6-luna": {
			id: "global.openai.gpt-6-luna",
			name: "GPT-6 Luna (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-6-sol": {
			id: "global.openai.gpt-6-sol",
			name: "GPT-6 Sol (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.openai.gpt-6.1-sol": {
			id: "global.openai.gpt-6.1-sol",
			name: "GPT-6.1 Sol (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.xai.grok-4.6": {
			id: "global.xai.grok-4.6",
			name: "Grok 4.6 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.xai.grok-4.7": {
			id: "global.xai.grok-4.7",
			name: "Grok 4.7 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"bedrock-converse-stream">,
		"global.zai.glm-5.3": {
			id: "global.zai.glm-5.3",
			name: "GLM-5.3 (Global)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.68,
				output: 5.28,
				cacheRead: 0.312,
				cacheWrite: 2.1,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"google.gemma-4-26b-a4b": {
			id: "google.gemma-4-26b-a4b",
			name: "Gemma 4 26B A4B IT",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.13,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"bedrock-converse-stream">,
		"google.gemma-4-31b": {
			id: "google.gemma-4-31b",
			name: "Gemma 4 31B IT",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"bedrock-converse-stream">,
		"google.gemma-4-e2b": {
			id: "google.gemma-4-e2b",
			name: "Gemma 4 E2B IT",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.04,
				output: 0.08,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"in.anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "in.anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5 (India)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 5.5,
				cacheRead: 0.11,
				cacheWrite: 1.375,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"in.anthropic.claude-opus-5": {
			id: "in.anthropic.claude-opus-5",
			name: "Claude Opus 5 (India)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"in.anthropic.claude-sonnet-5": {
			id: "in.anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5 (India)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"in.openai.gpt-5.6-luna": {
			id: "in.openai.gpt-5.6-luna",
			name: "GPT-5.6 Luna (India)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.22,
				output: 1.32,
				cacheRead: 0.022,
				cacheWrite: 0.275,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"in.openai.gpt-5.6-terra": {
			id: "in.openai.gpt-5.6-terra",
			name: "GPT-5.6 Terra (India)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 13.2,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.amazon.nova-2-lite-v1:0": {
			id: "jp.amazon.nova-2-lite-v1:0",
			name: "Nova 2 Lite (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.396,
				output: 3.311,
				cacheRead: 0.099,
				cacheWrite: 0.396,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "jp.anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 5.5,
				cacheRead: 0.11,
				cacheWrite: 1.375,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-haiku-5-5": {
			id: "jp.anthropic.claude-haiku-5-5",
			name: "Claude Haiku 5.5 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.11,
				output: 0.55,
				cacheRead: 0.011,
				cacheWrite: 0.1375,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-opus-4-7": {
			id: "jp.anthropic.claude-opus-4-7",
			name: "Claude Opus 4.7 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-opus-4-8": {
			id: "jp.anthropic.claude-opus-4-8",
			name: "Claude Opus 4.8 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-opus-5": {
			id: "jp.anthropic.claude-opus-5",
			name: "Claude Opus 5 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-opus-5-5": {
			id: "jp.anthropic.claude-opus-5-5",
			name: "Claude Opus 5.5 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.4,
				output: 22,
				cacheRead: 0.22,
				cacheWrite: 5.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-sonnet-4-5-20250929-v1:0": {
			id: "jp.anthropic.claude-sonnet-4-5-20250929-v1:0",
			name: "Claude Sonnet 4.5 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-sonnet-4-6": {
			id: "jp.anthropic.claude-sonnet-4-6",
			name: "Claude Sonnet 4.6 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"jp.anthropic.claude-sonnet-5": {
			id: "jp.anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5 (JP)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"meta.llama3-1-70b-instruct-v1:0": {
			id: "meta.llama3-1-70b-instruct-v1:0",
			name: "Llama 3.1 70B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.72,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"meta.llama3-1-8b-instruct-v1:0": {
			id: "meta.llama3-1-8b-instruct-v1:0",
			name: "Llama 3.1 8B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.22,
				output: 0.22,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"meta.llama3-3-70b-instruct-v1:0": {
			id: "meta.llama3-3-70b-instruct-v1:0",
			name: "Llama 3.3 70B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.72,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"meta.llama4-maverick-17b-instruct-v1:0": {
			id: "meta.llama4-maverick-17b-instruct-v1:0",
			name: "Llama 4 Maverick 17B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.24,
				output: 0.97,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"meta.llama4-scout-17b-instruct-v1:0": {
			id: "meta.llama4-scout-17b-instruct-v1:0",
			name: "Llama 4 Scout 17B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.17,
				output: 0.66,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 10000000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"minimax.minimax-m2": {
			id: "minimax.minimax-m2",
			name: "MiniMax-M2",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 204608,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"minimax.minimax-m2.1": {
			id: "minimax.minimax-m2.1",
			name: "MiniMax-M2.1",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 196608,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"minimax.minimax-m2.5": {
			id: "minimax.minimax-m2.5",
			name: "MiniMax-M2.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 196608,
			maxTokens: 98304,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.devstral-2-123b": {
			id: "mistral.devstral-2-123b",
			name: "Devstral 2 123B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.magistral-small-2509": {
			id: "mistral.magistral-small-2509",
			name: "Magistral Small 1.2",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 40000,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.ministral-3-14b-instruct": {
			id: "mistral.ministral-3-14b-instruct",
			name: "Ministral 14B 3.0",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 0.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.ministral-3-3b-instruct": {
			id: "mistral.ministral-3-3b-instruct",
			name: "Ministral 3 3B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.ministral-3-8b-instruct": {
			id: "mistral.ministral-3-8b-instruct",
			name: "Ministral 3 8B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.mistral-large-3-675b-instruct": {
			id: "mistral.mistral-large-3-675b-instruct",
			name: "Mistral Large 3",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.pixtral-large-2502-v1:0": {
			id: "mistral.pixtral-large-2502-v1:0",
			name: "Pixtral Large (25.02)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.voxtral-mini-3b-2507": {
			id: "mistral.voxtral-mini-3b-2507",
			name: "Voxtral Mini 3B 2507",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.04,
				output: 0.04,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"mistral.voxtral-small-24b-2507": {
			id: "mistral.voxtral-small-24b-2507",
			name: "Voxtral Small 24B 2507",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"moonshot.kimi-k2-thinking": {
			id: "moonshot.kimi-k2-thinking",
			name: "Kimi K2 Thinking",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16000,
		} satisfies Model<"bedrock-converse-stream">,
		"moonshotai.kimi-k2.5": {
			id: "moonshotai.kimi-k2.5",
			name: "Kimi K2.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"bedrock-converse-stream">,
		"nvidia.nemotron-nano-12b-v2": {
			id: "nvidia.nemotron-nano-12b-v2",
			name: "NVIDIA Nemotron Nano 12B v2 VL BF16",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"nvidia.nemotron-nano-3-30b": {
			id: "nvidia.nemotron-nano-3-30b",
			name: "NVIDIA Nemotron Nano 3 30B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.24,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"nvidia.nemotron-nano-9b-v2": {
			id: "nvidia.nemotron-nano-9b-v2",
			name: "NVIDIA Nemotron Nano 9B v2",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.23,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"nvidia.nemotron-super-3-120b": {
			id: "nvidia.nemotron-super-3-120b",
			name: "NVIDIA Nemotron 3 Super 120B A12B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.65,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-5.4": {
			id: "openai.gpt-5.4",
			name: "GPT-5.4",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.75,
				output: 16.5,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-5.5": {
			id: "openai.gpt-5.5",
			name: "GPT-5.5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 33,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-5.6-luna": {
			id: "openai.gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.22,
				output: 1.32,
				cacheRead: 0.022,
				cacheWrite: 0.275,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-5.6-sol": {
			id: "openai.gpt-5.6-sol",
			name: "GPT-5.6 Sol",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.4,
				output: 22,
				cacheRead: 0.44,
				cacheWrite: 5.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-5.6-terra": {
			id: "openai.gpt-5.6-terra",
			name: "GPT-5.6 Terra",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 13.2,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-6-astra": {
			id: "openai.gpt-6-astra",
			name: "GPT-6 Astra",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 11,
				output: 55,
				cacheRead: 1.1,
				cacheWrite: 13.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-6-luna": {
			id: "openai.gpt-6-luna",
			name: "GPT-6 Luna",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.11,
				output: 0.55,
				cacheRead: 0.011,
				cacheWrite: 0.1375,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-6-sol": {
			id: "openai.gpt-6-sol",
			name: "GPT-6 Sol",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-6.1-sol": {
			id: "openai.gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.11,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-oss-120b": {
			id: "openai.gpt-oss-120b",
			name: "gpt-oss-120b",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-oss-120b-1:0": {
			id: "openai.gpt-oss-120b-1:0",
			name: "gpt-oss-120b",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-oss-20b": {
			id: "openai.gpt-oss-20b",
			name: "gpt-oss-20b",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-oss-20b-1:0": {
			id: "openai.gpt-oss-20b-1:0",
			name: "gpt-oss-20b",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-oss-safeguard-120b": {
			id: "openai.gpt-oss-safeguard-120b",
			name: "GPT OSS Safeguard 120B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"bedrock-converse-stream">,
		"openai.gpt-oss-safeguard-20b": {
			id: "openai.gpt-oss-safeguard-20b",
			name: "GPT OSS Safeguard 20B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-235b-a22b-2507-v1:0": {
			id: "qwen.qwen3-235b-a22b-2507-v1:0",
			name: "Qwen3 235B-A22B Instruct 2507",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.22,
				output: 0.88,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-32b-v1:0": {
			id: "qwen.qwen3-32b-v1:0",
			name: "Qwen3 32B",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 16384,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-coder-30b-a3b-v1:0": {
			id: "qwen.qwen3-coder-30b-a3b-v1:0",
			name: "Qwen3-Coder 30B-A3B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-coder-480b-a35b-v1:0": {
			id: "qwen.qwen3-coder-480b-a35b-v1:0",
			name: "Qwen3-Coder 480B-A35B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.45,
				output: 1.8,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-coder-next": {
			id: "qwen.qwen3-coder-next",
			name: "Qwen3 Coder Next",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.5,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-next-80b-a3b": {
			id: "qwen.qwen3-next-80b-a3b",
			name: "Qwen3-Next 80B-A3B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262000,
		} satisfies Model<"bedrock-converse-stream">,
		"qwen.qwen3-vl-235b-a22b": {
			id: "qwen.qwen3-vl-235b-a22b",
			name: "Qwen3 VL 235B A22B Instruct",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.53,
				output: 2.66,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262000,
		} satisfies Model<"bedrock-converse-stream">,
		"us-gov.openai.gpt-oss-120b-1:0": {
			id: "us-gov.openai.gpt-oss-120b-1:0",
			name: "gpt-oss-120b (GovCloud)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.18,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"bedrock-converse-stream">,
		"us-gov.openai.gpt-oss-20b-1:0": {
			id: "us-gov.openai.gpt-oss-20b-1:0",
			name: "gpt-oss-20b (GovCloud)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.084,
				output: 0.36,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"bedrock-converse-stream">,
		"us.amazon.nova-2-lite-v1:0": {
			id: "us.amazon.nova-2-lite-v1:0",
			name: "Nova 2 Lite (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.33,
				output: 2.75,
				cacheRead: 0.0825,
				cacheWrite: 0.33,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"bedrock-converse-stream">,
		"us.amazon.nova-lite-v1:0": {
			id: "us.amazon.nova-lite-v1:0",
			name: "Nova Lite (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.06,
				output: 0.24,
				cacheRead: 0.015,
				cacheWrite: 0.06,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.amazon.nova-micro-v1:0": {
			id: "us.amazon.nova-micro-v1:0",
			name: "Nova Micro (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.035,
				output: 0.14,
				cacheRead: 0.00875,
				cacheWrite: 0.035,
			},
			contextWindow: 128000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.amazon.nova-premier-v1:0": {
			id: "us.amazon.nova-premier-v1:0",
			name: "Nova Premier (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.625,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.amazon.nova-pro-v1:0": {
			id: "us.amazon.nova-pro-v1:0",
			name: "Nova Pro (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.8,
				output: 3.2,
				cacheRead: 0.2,
				cacheWrite: 0.8,
			},
			contextWindow: 300000,
			maxTokens: 10000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-fable-5": {
			id: "us.anthropic.claude-fable-5",
			name: "Claude Fable 5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 11,
				output: 55,
				cacheRead: 1.1,
				cacheWrite: 13.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-fable-5-1": {
			id: "us.anthropic.claude-fable-5-1",
			name: "Claude Fable 5.1 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 11,
				output: 55,
				cacheRead: 0.275,
				cacheWrite: 13.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-haiku-4-5-20251001-v1:0": {
			id: "us.anthropic.claude-haiku-4-5-20251001-v1:0",
			name: "Claude Haiku 4.5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 5.5,
				cacheRead: 0.11,
				cacheWrite: 1.375,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-haiku-5-5": {
			id: "us.anthropic.claude-haiku-5-5",
			name: "Claude Haiku 5.5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.11,
				output: 0.55,
				cacheRead: 0.011,
				cacheWrite: 0.1375,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-4-1-20250805-v1:0": {
			id: "us.anthropic.claude-opus-4-1-20250805-v1:0",
			name: "Claude Opus 4.1 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 75,
				cacheRead: 1.5,
				cacheWrite: 18.75,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-4-5-20251101-v1:0": {
			id: "us.anthropic.claude-opus-4-5-20251101-v1:0",
			name: "Claude Opus 4.5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-4-6-v1": {
			id: "us.anthropic.claude-opus-4-6-v1",
			name: "Claude Opus 4.6 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-4-7": {
			id: "us.anthropic.claude-opus-4-7",
			name: "Claude Opus 4.7 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-4-8": {
			id: "us.anthropic.claude-opus-4-8",
			name: "Claude Opus 4.8 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-5": {
			id: "us.anthropic.claude-opus-5",
			name: "Claude Opus 5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5.5,
				output: 27.5,
				cacheRead: 0.55,
				cacheWrite: 6.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-opus-5-5": {
			id: "us.anthropic.claude-opus-5-5",
			name: "Claude Opus 5.5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.4,
				output: 22,
				cacheRead: 0.22,
				cacheWrite: 5.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-sonnet-4-20250514-v1:0": {
			id: "us.anthropic.claude-sonnet-4-20250514-v1:0",
			name: "Claude Sonnet 4 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-sonnet-4-5-20250929-v1:0": {
			id: "us.anthropic.claude-sonnet-4-5-20250929-v1:0",
			name: "Claude Sonnet 4.5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-sonnet-4-6": {
			id: "us.anthropic.claude-sonnet-4-6",
			name: "Claude Sonnet 4.6 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-sonnet-5": {
			id: "us.anthropic.claude-sonnet-5",
			name: "Claude Sonnet 5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.anthropic.claude-sonnet-5-5": {
			id: "us.anthropic.claude-sonnet-5-5",
			name: "Claude Sonnet 5.5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.11,
				cacheWrite: 2.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.meta.llama3-1-70b-instruct-v1:0": {
			id: "us.meta.llama3-1-70b-instruct-v1:0",
			name: "Llama 3.1 70B Instruct (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.72,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"us.meta.llama3-1-8b-instruct-v1:0": {
			id: "us.meta.llama3-1-8b-instruct-v1:0",
			name: "Llama 3.1 8B Instruct (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.22,
				output: 0.22,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"us.meta.llama3-3-70b-instruct-v1:0": {
			id: "us.meta.llama3-3-70b-instruct-v1:0",
			name: "Llama 3.3 70B Instruct (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.72,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"bedrock-converse-stream">,
		"us.meta.llama4-maverick-17b-instruct-v1:0": {
			id: "us.meta.llama4-maverick-17b-instruct-v1:0",
			name: "Llama 4 Maverick 17B Instruct (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.24,
				output: 0.97,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"us.meta.llama4-scout-17b-instruct-v1:0": {
			id: "us.meta.llama4-scout-17b-instruct-v1:0",
			name: "Llama 4 Scout 17B Instruct (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.17,
				output: 0.66,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 10000000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"us.mistral.pixtral-large-2502-v1:0": {
			id: "us.mistral.pixtral-large-2502-v1:0",
			name: "Pixtral Large (25.02) (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"us.moonshotai.kimi-k3": {
			id: "us.moonshotai.kimi-k3",
			name: "Kimi K3 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.3,
				output: 16.5,
				cacheRead: 0.33,
				cacheWrite: 4.125,
			},
			contextWindow: 1048576,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-5.6-luna": {
			id: "us.openai.gpt-5.6-luna",
			name: "GPT-5.6 Luna (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.22,
				output: 1.32,
				cacheRead: 0.022,
				cacheWrite: 0.275,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-5.6-sol": {
			id: "us.openai.gpt-5.6-sol",
			name: "GPT-5.6 Sol (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.4,
				output: 22,
				cacheRead: 0.44,
				cacheWrite: 5.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-5.6-terra": {
			id: "us.openai.gpt-5.6-terra",
			name: "GPT-5.6 Terra (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 13.2,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-6-astra": {
			id: "us.openai.gpt-6-astra",
			name: "GPT-6 Astra (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 11,
				output: 55,
				cacheRead: 1.1,
				cacheWrite: 13.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-6-luna": {
			id: "us.openai.gpt-6-luna",
			name: "GPT-6 Luna (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.11,
				output: 0.55,
				cacheRead: 0.011,
				cacheWrite: 0.1375,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-6-sol": {
			id: "us.openai.gpt-6-sol",
			name: "GPT-6 Sol (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.22,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.openai.gpt-6.1-sol": {
			id: "us.openai.gpt-6.1-sol",
			name: "GPT-6.1 Sol (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 11,
				cacheRead: 0.11,
				cacheWrite: 2.75,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.writer.palmyra-x4-v1:0": {
			id: "us.writer.palmyra-x4-v1:0",
			name: "Palmyra X4 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 122880,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"us.writer.palmyra-x5-v1:0": {
			id: "us.writer.palmyra-x5-v1:0",
			name: "Palmyra X5 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1040000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"us.xai.grok-4.6": {
			id: "us.xai.grok-4.6",
			name: "Grok 4.6 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 6.6,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.xai.grok-4.7": {
			id: "us.xai.grok-4.7",
			name: "Grok 4.7 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 6.6,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"bedrock-converse-stream">,
		"us.zai.glm-5.3": {
			id: "us.zai.glm-5.3",
			name: "GLM-5.3 (US)",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.848,
				output: 5.808,
				cacheRead: 0.3432,
				cacheWrite: 2.31,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"bedrock-converse-stream">,
		"writer.palmyra-x4-v1:0": {
			id: "writer.palmyra-x4-v1:0",
			name: "Palmyra X4",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 122880,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"writer.palmyra-x5-v1:0": {
			id: "writer.palmyra-x5-v1:0",
			name: "Palmyra X5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1040000,
			maxTokens: 8192,
		} satisfies Model<"bedrock-converse-stream">,
		"xai.grok-4.3": {
			id: "xai.grok-4.3",
			name: "Grok 4.3",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"xai.grok-4.6": {
			id: "xai.grok-4.6",
			name: "Grok 4.6",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2,
				output: 6.6,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"bedrock-converse-stream">,
		"zai.glm-4.7": {
			id: "zai.glm-4.7",
			name: "GLM-4.7",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"zai.glm-4.7-flash": {
			id: "zai.glm-4.7-flash",
			name: "GLM-4.7-Flash",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
		"zai.glm-5": {
			id: "zai.glm-5",
			name: "GLM-5",
			api: "bedrock-converse-stream",
			provider: "amazon-bedrock",
			baseUrl: "https://bedrock-runtime.us-east-1.amazonaws.com",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1,
				output: 3.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"bedrock-converse-stream">,
	},
	"anthropic": {
		"claude-fable-5": {
			id: "claude-fable-5",
			name: "Claude Fable 5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-fable-5-1": {
			id: "claude-fable-5-1",
			name: "Claude Fable 5.1",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-haiku-4-5": {
			id: "claude-haiku-4-5",
			name: "Claude Haiku 4.5 (latest)",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.1,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-haiku-4-5-20251001": {
			id: "claude-haiku-4-5-20251001",
			name: "Claude Haiku 4.5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.1,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-haiku-5-5": {
			id: "claude-haiku-5-5",
			name: "Claude Haiku 5.5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-5": {
			id: "claude-opus-4-5",
			name: "Claude Opus 4.5 (latest)",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-5-20251101": {
			id: "claude-opus-4-5-20251101",
			name: "Claude Opus 4.5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-6": {
			id: "claude-opus-4-6",
			name: "Claude Opus 4.6",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-7": {
			id: "claude-opus-4-7",
			name: "Claude Opus 4.7",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-8": {
			id: "claude-opus-4-8",
			name: "Claude Opus 4.8",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-5": {
			id: "claude-opus-5",
			name: "Claude Opus 5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-5-5": {
			id: "claude-opus-5-5",
			name: "Claude Opus 5.5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.2,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-4-5": {
			id: "claude-sonnet-4-5",
			name: "Claude Sonnet 4.5 (latest)",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-4-5-20250929": {
			id: "claude-sonnet-4-5-20250929",
			name: "Claude Sonnet 4.5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-4-6": {
			id: "claude-sonnet-4-6",
			name: "Claude Sonnet 4.6",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-5": {
			id: "claude-sonnet-5",
			name: "Claude Sonnet 5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-5-5": {
			id: "claude-sonnet-5-5",
			name: "Claude Sonnet 5.5",
			api: "anthropic-messages",
			provider: "anthropic",
			baseUrl: "https://api.anthropic.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
	},
	"azure-openai-responses": {
		"gpt-4": {
			id: "gpt-4",
			name: "GPT-4",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 30,
				output: 60,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 8192,
			maxTokens: 8192,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4-turbo": {
			id: "gpt-4-turbo",
			name: "GPT-4 Turbo",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 30,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4.1": {
			id: "gpt-4.1",
			name: "GPT-4.1",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4.1-mini": {
			id: "gpt-4.1-mini",
			name: "GPT-4.1 mini",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 1.6,
				cacheRead: 0.1,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4.1-nano": {
			id: "gpt-4.1-nano",
			name: "GPT-4.1 nano",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.4,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4o": {
			id: "gpt-4o",
			name: "GPT-4o",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4o-2024-05-13": {
			id: "gpt-4o-2024-05-13",
			name: "GPT-4o (2024-05-13)",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4o-2024-08-06": {
			id: "gpt-4o-2024-08-06",
			name: "GPT-4o (2024-08-06)",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4o-2024-11-20": {
			id: "gpt-4o-2024-11-20",
			name: "GPT-4o (2024-11-20)",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-4o-mini": {
			id: "gpt-4o-mini",
			name: "GPT-4o mini",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5": {
			id: "gpt-5",
			name: "GPT-5",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5-chat-latest": {
			id: "gpt-5-chat-latest",
			name: "GPT-5 Chat Latest",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5-mini": {
			id: "gpt-5-mini",
			name: "GPT-5 Mini",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5-nano": {
			id: "gpt-5-nano",
			name: "GPT-5 Nano",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.05,
				output: 0.4,
				cacheRead: 0.005,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5-pro": {
			id: "gpt-5-pro",
			name: "GPT-5 Pro",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 120,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 272000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.1": {
			id: "gpt-5.1",
			name: "GPT-5.1",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.1-codex": {
			id: "gpt-5.1-codex",
			name: "GPT-5.1 Codex",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 5,
				cacheRead: 0.125,
				cacheWrite: 1.25,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.1-codex-max": {
			id: "gpt-5.1-codex-max",
			name: "GPT-5.1 Codex Max",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.2": {
			id: "gpt-5.2",
			name: "GPT-5.2",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.2-chat-latest": {
			id: "gpt-5.2-chat-latest",
			name: "GPT-5.2 Chat",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.2-pro": {
			id: "gpt-5.2-pro",
			name: "GPT-5.2 Pro",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 21,
				output: 168,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.3-chat-latest": {
			id: "gpt-5.3-chat-latest",
			name: "GPT-5.3 Chat (latest)",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.3-codex": {
			id: "gpt-5.3-codex",
			name: "GPT-5.3 Codex",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.3-codex-spark": {
			id: "gpt-5.3-codex-spark",
			name: "GPT-5.3 Codex Spark",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 32000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.4": {
			id: "gpt-5.4",
			name: "GPT-5.4",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.4-mini": {
			id: "gpt-5.4-mini",
			name: "GPT-5.4 mini",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.4-nano": {
			id: "gpt-5.4-nano",
			name: "GPT-5.4 nano",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.25,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.4-pro": {
			id: "gpt-5.4-pro",
			name: "GPT-5.4 Pro",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.5": {
			id: "gpt-5.5",
			name: "GPT-5.5",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.5-pro": {
			id: "gpt-5.5-pro",
			name: "GPT-5.5 Pro",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.6": {
			id: "gpt-5.6",
			name: "GPT-5.6",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.6-luna": {
			id: "gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.6-sol": {
			id: "gpt-5.6-sol",
			name: "GPT-5.6 Sol",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-5.6-terra": {
			id: "gpt-5.6-terra",
			name: "GPT-5.6 Terra",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-6-astra": {
			id: "gpt-6-astra",
			name: "GPT-6 Astra",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-6-luna": {
			id: "gpt-6-luna",
			name: "GPT-6 Luna",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-6-sol": {
			id: "gpt-6-sol",
			name: "GPT-6 Sol",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-6.1-sol": {
			id: "gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-daybreak-blue-latest": {
			id: "gpt-daybreak-blue-latest",
			name: "Daybreak Blue",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-daybreak-red-latest": {
			id: "gpt-daybreak-red-latest",
			name: "Daybreak Red",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 12.5,
				output: 75,
				cacheRead: 1.25,
				cacheWrite: 15.625,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"azure-openai-responses">,
		"gpt-realtime-2.1": {
			id: "gpt-realtime-2.1",
			name: "GPT-Realtime-2.1",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 24,
				cacheRead: 0.4,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 32000,
		} satisfies Model<"azure-openai-responses">,
		"o1": {
			id: "o1",
			name: "o1",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 60,
				cacheRead: 7.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"azure-openai-responses">,
		"o1-pro": {
			id: "o1-pro",
			name: "o1-pro",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 150,
				output: 600,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"azure-openai-responses">,
		"o3": {
			id: "o3",
			name: "o3",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"azure-openai-responses">,
		"o3-mini": {
			id: "o3-mini",
			name: "o3-mini",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"azure-openai-responses">,
		"o3-pro": {
			id: "o3-pro",
			name: "o3-pro",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 20,
				output: 80,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"azure-openai-responses">,
		"o4-mini": {
			id: "o4-mini",
			name: "o4-mini",
			api: "azure-openai-responses",
			provider: "azure-openai-responses",
			baseUrl: "",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"azure-openai-responses">,
	},
	"cerebras": {
		"gpt-oss-120b": {
			id: "gpt-oss-120b",
			name: "GPT OSS 120B",
			api: "openai-completions",
			provider: "cerebras",
			baseUrl: "https://api.cerebras.ai/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.35,
				output: 0.75,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 40960,
		} satisfies Model<"openai-completions">,
		"qwen-3.8-27b": {
			id: "qwen-3.8-27b",
			name: "Qwen3.8 27B",
			api: "openai-completions",
			provider: "cerebras",
			baseUrl: "https://api.cerebras.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.99,
				output: 1.49,
				cacheRead: 0.99,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 40960,
		} satisfies Model<"openai-completions">,
	},
	"github-copilot": {
		"claude-fable-5": {
			id: "claude-fable-5",
			name: "Claude Fable 5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"claude-fable-5.1": {
			id: "claude-fable-5.1",
			name: "Claude Fable 5.1",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"claude-haiku-4.5": {
			id: "claude-haiku-4.5",
			name: "Claude Haiku 4.5 (latest)",
			api: "anthropic-messages",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.1,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-haiku-5.5": {
			id: "claude-haiku-5.5",
			name: "Claude Haiku 5.5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"claude-opus-4.7": {
			id: "claude-opus-4.7",
			name: "Claude Opus 4.7",
			api: "anthropic-messages",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4.8": {
			id: "claude-opus-4.8",
			name: "Claude Opus 4.8",
			api: "anthropic-messages",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-5": {
			id: "claude-opus-5",
			name: "Claude Opus 5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"claude-opus-5.5": {
			id: "claude-opus-5.5",
			name: "Claude Opus 5.5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.2,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"claude-sonnet-4.6": {
			id: "claude-sonnet-4.6",
			name: "Claude Sonnet 4.6",
			api: "anthropic-messages",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-5": {
			id: "claude-sonnet-5",
			name: "Claude Sonnet 5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"claude-sonnet-5.5": {
			id: "claude-sonnet-5.5",
			name: "Claude Sonnet 5.5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"gemini-3.5-flash": {
			id: "gemini-3.5-flash",
			name: "Gemini 3.5 Flash",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 9,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"gemini-3.6-flash": {
			id: "gemini-3.6-flash",
			name: "Gemini 3.6 Flash",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"gemini-3.7-flash": {
			id: "gemini-3.7-flash",
			name: "Gemini 3.7 Flash",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"gemini-3.8-flash": {
			id: "gemini-3.8-flash",
			name: "Gemini 3.8 Flash",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"gpt-5-mini": {
			id: "gpt-5-mini",
			name: "GPT-5 Mini",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 264000,
			maxTokens: 64000,
		} satisfies Model<"openai-responses">,
		"gpt-5.3-codex": {
			id: "gpt-5.3-codex",
			name: "GPT-5.3 Codex",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4": {
			id: "gpt-5.4",
			name: "GPT-5.4",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-mini": {
			id: "gpt-5.4-mini",
			name: "GPT-5.4 mini",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-nano": {
			id: "gpt-5.4-nano",
			name: "GPT-5.4 nano",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.25,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.5": {
			id: "gpt-5.5",
			name: "GPT-5.5",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-luna": {
			id: "gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-sol": {
			id: "gpt-5.6-sol",
			name: "GPT-5.6 Sol",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-terra": {
			id: "gpt-5.6-terra",
			name: "GPT-5.6 Terra",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-astra": {
			id: "gpt-6-astra",
			name: "GPT-6 Astra",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-luna": {
			id: "gpt-6-luna",
			name: "GPT-6 Luna",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-sol": {
			id: "gpt-6-sol",
			name: "GPT-6 Sol",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6.1-sol": {
			id: "gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "openai-responses",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"grok-4.5": {
			id: "grok-4.5",
			name: "Grok 4.5",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"grok-4.6": {
			id: "grok-4.6",
			name: "Grok 4.6",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"grok-4.7": {
			id: "grok-4.7",
			name: "Grok 4.7",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"kimi-k2.7-code": {
			id: "kimi-k2.7-code",
			name: "Kimi K2.7 Code",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.19,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"kimi-k3": {
			id: "kimi-k3",
			name: "Kimi K3",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"mai-code-1-flash-picker": {
			id: "mai-code-1-flash-picker",
			name: "MAI-Code-1-Flash",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"mai-code-1.1-flash": {
			id: "mai-code-1.1-flash",
			name: "MAI-Code-1.1-Flash",
			api: "openai-completions",
			provider: "github-copilot",
			baseUrl: "https://api.individual.githubcopilot.com",
			headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
			compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
	},
	"google": {
		"deep-research-max-preview-04-2026": {
			id: "deep-research-max-preview-04-2026",
			name: "Deep Research Max Preview (Apr-21-2026)",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"deep-research-preview-04-2026": {
			id: "deep-research-preview-04-2026",
			name: "Deep Research Preview (Apr-21-2026)",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-2.5-computer-use-preview-10-2025": {
			id: "gemini-2.5-computer-use-preview-10-2025",
			name: "Gemini 2.5 Computer Use Preview 10-2025",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 64000,
		} satisfies Model<"google-generative-ai">,
		"gemini-2.5-flash": {
			id: "gemini-2.5-flash",
			name: "Gemini 2.5 Flash",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-2.5-flash-lite": {
			id: "gemini-2.5-flash-lite",
			name: "Gemini 2.5 Flash-Lite",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.4,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-2.5-pro": {
			id: "gemini-2.5-pro",
			name: "Gemini 2.5 Pro",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3-flash-preview": {
			id: "gemini-3-flash-preview",
			name: "Gemini 3 Flash Preview",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.05,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-flash-lite": {
			id: "gemini-3.1-flash-lite",
			name: "Gemini 3.1 Flash Lite",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.5,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-flash-lite-image": {
			id: "gemini-3.1-flash-lite-image",
			name: "Nano Banana 2 Lite",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 30,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 65536,
			maxTokens: 4096,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-flash-lite-preview": {
			id: "gemini-3.1-flash-lite-preview",
			name: "Gemini 3.1 Flash Lite Preview",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.5,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-flash-live-preview": {
			id: "gemini-3.1-flash-live-preview",
			name: "Gemini 3.1 Flash Live Preview",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-pro-preview": {
			id: "gemini-3.1-pro-preview",
			name: "Gemini 3.1 Pro Preview",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-pro-preview-customtools": {
			id: "gemini-3.1-pro-preview-customtools",
			name: "Gemini 3.1 Pro Preview Custom Tools",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.5-flash": {
			id: "gemini-3.5-flash",
			name: "Gemini 3.5 Flash",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 9,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.5-flash-lite": {
			id: "gemini-3.5-flash-lite",
			name: "Gemini 3.5 Flash Lite",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.6-flash": {
			id: "gemini-3.6-flash",
			name: "Gemini 3.6 Flash",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.7-flash": {
			id: "gemini-3.7-flash",
			name: "Gemini 3.7 Flash",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.8-flash": {
			id: "gemini-3.8-flash",
			name: "Gemini 3.8 Flash",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-flash-latest": {
			id: "gemini-flash-latest",
			name: "Gemini Flash Latest",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-flash-lite-latest": {
			id: "gemini-flash-lite-latest",
			name: "Gemini Flash-Lite Latest",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemma-4-26b-a4b-it": {
			id: "gemma-4-26b-a4b-it",
			name: "Gemma 4 26B A4B IT",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"google-generative-ai">,
		"gemma-4-31b-it": {
			id: "gemma-4-31b-it",
			name: "Gemma 4 31B IT",
			api: "google-generative-ai",
			provider: "google",
			baseUrl: "https://generativelanguage.googleapis.com/v1beta",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"google-generative-ai">,
	},
	"google-antigravity": {
		"claude-opus-4-5-thinking": {
			id: "claude-opus-4-5-thinking",
			name: "Claude Opus 4.5 Thinking (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"google-gemini-cli">,
		"claude-opus-4-6-thinking": {
			id: "claude-opus-4-6-thinking",
			name: "Claude Opus 4.6 Thinking (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 128000,
		} satisfies Model<"google-gemini-cli">,
		"claude-sonnet-4-5": {
			id: "claude-sonnet-4-5",
			name: "Claude Sonnet 4.5 (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"google-gemini-cli">,
		"claude-sonnet-4-5-thinking": {
			id: "claude-sonnet-4-5-thinking",
			name: "Claude Sonnet 4.5 Thinking (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"google-gemini-cli">,
		"claude-sonnet-4-6": {
			id: "claude-sonnet-4-6",
			name: "Claude Sonnet 4.6 (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"google-gemini-cli">,
		"gemini-3-flash": {
			id: "gemini-3-flash",
			name: "Gemini 3 Flash (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gemini-3.1-pro-high": {
			id: "gemini-3.1-pro-high",
			name: "Gemini 3.1 Pro High (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.375,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gemini-3.1-pro-low": {
			id: "gemini-3.1-pro-low",
			name: "Gemini 3.1 Pro Low (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.375,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gpt-oss-120b-medium": {
			id: "gpt-oss-120b-medium",
			name: "GPT-OSS 120B Medium (Antigravity)",
			api: "google-gemini-cli",
			provider: "google-antigravity",
			baseUrl: "https://daily-cloudcode-pa.sandbox.googleapis.com",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.09,
				output: 0.36,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"google-gemini-cli">,
	},
	"google-gemini-cli": {
		"gemini-2.0-flash": {
			id: "gemini-2.0-flash",
			name: "Gemini 2.0 Flash (Cloud Code Assist)",
			api: "google-gemini-cli",
			provider: "google-gemini-cli",
			baseUrl: "https://cloudcode-pa.googleapis.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 8192,
		} satisfies Model<"google-gemini-cli">,
		"gemini-2.5-flash": {
			id: "gemini-2.5-flash",
			name: "Gemini 2.5 Flash (Cloud Code Assist)",
			api: "google-gemini-cli",
			provider: "google-gemini-cli",
			baseUrl: "https://cloudcode-pa.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gemini-2.5-pro": {
			id: "gemini-2.5-pro",
			name: "Gemini 2.5 Pro (Cloud Code Assist)",
			api: "google-gemini-cli",
			provider: "google-gemini-cli",
			baseUrl: "https://cloudcode-pa.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gemini-3-flash-preview": {
			id: "gemini-3-flash-preview",
			name: "Gemini 3 Flash Preview (Cloud Code Assist)",
			api: "google-gemini-cli",
			provider: "google-gemini-cli",
			baseUrl: "https://cloudcode-pa.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gemini-3-pro-preview": {
			id: "gemini-3-pro-preview",
			name: "Gemini 3 Pro Preview (Cloud Code Assist)",
			api: "google-gemini-cli",
			provider: "google-gemini-cli",
			baseUrl: "https://cloudcode-pa.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
		"gemini-3.1-pro-preview": {
			id: "gemini-3.1-pro-preview",
			name: "Gemini 3.1 Pro Preview (Cloud Code Assist)",
			api: "google-gemini-cli",
			provider: "google-gemini-cli",
			baseUrl: "https://cloudcode-pa.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"google-gemini-cli">,
	},
	"google-vertex": {
		"gemini-1.5-flash": {
			id: "gemini-1.5-flash",
			name: "Gemini 1.5 Flash (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0.01875,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 8192,
		} satisfies Model<"google-vertex">,
		"gemini-1.5-flash-8b": {
			id: "gemini-1.5-flash-8b",
			name: "Gemini 1.5 Flash-8B (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.0375,
				output: 0.15,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 8192,
		} satisfies Model<"google-vertex">,
		"gemini-1.5-pro": {
			id: "gemini-1.5-pro",
			name: "Gemini 1.5 Pro (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 5,
				cacheRead: 0.3125,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 8192,
		} satisfies Model<"google-vertex">,
		"gemini-2.0-flash": {
			id: "gemini-2.0-flash",
			name: "Gemini 2.0 Flash (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.0375,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 8192,
		} satisfies Model<"google-vertex">,
		"gemini-2.0-flash-lite": {
			id: "gemini-2.0-flash-lite",
			name: "Gemini 2.0 Flash Lite (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0.01875,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
		"gemini-2.5-flash": {
			id: "gemini-2.5-flash",
			name: "Gemini 2.5 Flash (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
		"gemini-2.5-flash-lite": {
			id: "gemini-2.5-flash-lite",
			name: "Gemini 2.5 Flash Lite (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.4,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
		"gemini-2.5-flash-lite-preview-09-2025": {
			id: "gemini-2.5-flash-lite-preview-09-2025",
			name: "Gemini 2.5 Flash Lite Preview 09-25 (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.4,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
		"gemini-2.5-pro": {
			id: "gemini-2.5-pro",
			name: "Gemini 2.5 Pro (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
		"gemini-3-flash-preview": {
			id: "gemini-3-flash-preview",
			name: "Gemini 3 Flash Preview (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.05,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
		"gemini-3-pro-preview": {
			id: "gemini-3-pro-preview",
			name: "Gemini 3 Pro Preview (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"google-vertex">,
		"gemini-3.1-pro-preview": {
			id: "gemini-3.1-pro-preview",
			name: "Gemini 3.1 Pro Preview (Vertex)",
			api: "google-vertex",
			provider: "google-vertex",
			baseUrl: "https://{location}-aiplatform.googleapis.com",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-vertex">,
	},
	"groq": {
		"llama-3.1-8b-instant": {
			id: "llama-3.1-8b-instant",
			name: "Llama 3.1 8B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.05,
				output: 0.08,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"llama-3.3-70b-versatile": {
			id: "llama-3.3-70b-versatile",
			name: "Llama 3.3 70B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.59,
				output: 0.79,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-120b": {
			id: "openai/gpt-oss-120b",
			name: "GPT OSS 120B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-20b": {
			id: "openai/gpt-oss-20b",
			name: "GPT OSS 20B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0.0375,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-safeguard-20b": {
			id: "openai/gpt-oss-safeguard-20b",
			name: "Safety GPT OSS 20B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.6-27b": {
			id: "qwen/qwen3.6-27b",
			name: "Qwen3.6 27B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-27b": {
			id: "qwen/qwen3.8-27b",
			name: "Qwen3.8 27B",
			api: "openai-completions",
			provider: "groq",
			baseUrl: "https://api.groq.com/openai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.8,
				output: 4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131042,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
	},
	"huggingface": {
		"MiniMaxAI/MiniMax-M2": {
			id: "MiniMaxAI/MiniMax-M2",
			name: "MiniMax-M2",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"MiniMaxAI/MiniMax-M2.1": {
			id: "MiniMaxAI/MiniMax-M2.1",
			name: "MiniMax-M2.1",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"MiniMaxAI/MiniMax-M2.5": {
			id: "MiniMaxAI/MiniMax-M2.5",
			name: "MiniMax-M2.5",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"MiniMaxAI/MiniMax-M2.7": {
			id: "MiniMaxAI/MiniMax-M2.7",
			name: "MiniMax-M2.7",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"MiniMaxAI/MiniMax-M3": {
			id: "MiniMaxAI/MiniMax-M3",
			name: "MiniMax-M3",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 512000,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen2.5-Coder-32B-Instruct": {
			id: "Qwen/Qwen2.5-Coder-32B-Instruct",
			name: "Qwen2.5-Coder-32B-Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 8192,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-235B-A22B": {
			id: "Qwen/Qwen3-235B-A22B",
			name: "Qwen3 235B-A22B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.2,
				output: 0.8,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 40960,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-235B-A22B-Instruct-2507": {
			id: "Qwen/Qwen3-235B-A22B-Instruct-2507",
			name: "Qwen3 235B-A22B Instruct 2507",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.855,
				output: 2.565,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-235B-A22B-Thinking-2507": {
			id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
			name: "Qwen3-235B-A22B-Thinking-2507",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-30B-A3B": {
			id: "Qwen/Qwen3-30B-A3B",
			name: "Qwen3 30B A3B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.12,
				output: 0.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 40960,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-32B": {
			id: "Qwen/Qwen3-32B",
			name: "Qwen3 32B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.29,
				output: 0.59,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-Coder-30B-A3B-Instruct": {
			id: "Qwen/Qwen3-Coder-30B-A3B-Instruct",
			name: "Qwen3-Coder 30B-A3B Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.26,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-Coder-480B-A35B-Instruct": {
			id: "Qwen/Qwen3-Coder-480B-A35B-Instruct",
			name: "Qwen3-Coder-480B-A35B-Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 66536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-Coder-Next": {
			id: "Qwen/Qwen3-Coder-Next",
			name: "Qwen3-Coder-Next",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.2,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-Next-80B-A3B-Instruct": {
			id: "Qwen/Qwen3-Next-80B-A3B-Instruct",
			name: "Qwen3-Next-80B-A3B-Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 66536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-Next-80B-A3B-Thinking": {
			id: "Qwen/Qwen3-Next-80B-A3B-Thinking",
			name: "Qwen3-Next-80B-A3B-Thinking",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-VL-235B-A22B-Instruct": {
			id: "Qwen/Qwen3-VL-235B-A22B-Instruct",
			name: "Qwen3 VL 235B A22B Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3-VL-235B-A22B-Thinking": {
			id: "Qwen/Qwen3-VL-235B-A22B-Thinking",
			name: "Qwen3 VL 235B A22B Thinking",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.98,
				output: 3.95,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.5-122B-A10B": {
			id: "Qwen/Qwen3.5-122B-A10B",
			name: "Qwen3.5 122B-A10B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 3.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.5-27B": {
			id: "Qwen/Qwen3.5-27B",
			name: "Qwen3.5 27B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.5-35B-A3B": {
			id: "Qwen/Qwen3.5-35B-A3B",
			name: "Qwen3.5 35B-A3B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.5-397B-A17B": {
			id: "Qwen/Qwen3.5-397B-A17B",
			name: "Qwen3.5-397B-A17B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.5-9B": {
			id: "Qwen/Qwen3.5-9B",
			name: "Qwen3.5 9B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.17,
				output: 0.25,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.6-27B": {
			id: "Qwen/Qwen3.6-27B",
			name: "Qwen3.6 27B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.47,
				output: 3.19,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.6-35B-A3B": {
			id: "Qwen/Qwen3.6-35B-A3B",
			name: "Qwen3.6 35B-A3B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.95,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.8-2.4T-A95B": {
			id: "Qwen/Qwen3.8-2.4T-A95B",
			name: "Qwen3.8 2.4T A95B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 6.25,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"Qwen/Qwen3.8-27B": {
			id: "Qwen/Qwen3.8-27B",
			name: "Qwen3.8 27B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"XiaomiMiMo/MiMo-V2-Flash": {
			id: "XiaomiMiMo/MiMo-V2-Flash",
			name: "MiMo-V2-Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"XiaomiMiMo/MiMo-V2.5": {
			id: "XiaomiMiMo/MiMo-V2.5",
			name: "MiMo-V2.5",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"XiaomiMiMo/MiMo-V2.5-Pro": {
			id: "XiaomiMiMo/MiMo-V2.5-Pro",
			name: "MiMo-V2.5-Pro",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-R1": {
			id: "deepseek-ai/DeepSeek-R1",
			name: "DeepSeek-R1",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 64000,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-R1-0528": {
			id: "deepseek-ai/DeepSeek-R1-0528",
			name: "DeepSeek-R1-0528",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 3,
				output: 5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 163840,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V3": {
			id: "deepseek-ai/DeepSeek-V3",
			name: "DeepSeek-V3",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 1.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 64000,
			maxTokens: 8192,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V3-0324": {
			id: "deepseek-ai/DeepSeek-V3-0324",
			name: "DeepSeek V3 0324",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.27,
				output: 1.12,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 163840,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V3.1": {
			id: "deepseek-ai/DeepSeek-V3.1",
			name: "DeepSeek-V3.1",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.27,
				output: 1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 8192,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V3.2": {
			id: "deepseek-ai/DeepSeek-V3.2",
			name: "DeepSeek-V3.2",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.28,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V4-Flash": {
			id: "deepseek-ai/DeepSeek-V4-Flash",
			name: "DeepSeek V4 Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V4-Flash-0731": {
			id: "deepseek-ai/DeepSeek-V4-Flash-0731",
			name: "DeepSeek V4 Flash 0731",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V4-Flash-Vision-Exp": {
			id: "deepseek-ai/DeepSeek-V4-Flash-Vision-Exp",
			name: "DeepSeek V4 Flash Vision Exp",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.44,
				output: 1.32,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V4-Pro": {
			id: "deepseek-ai/DeepSeek-V4-Pro",
			name: "DeepSeek V4 Pro",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.003625,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 393216,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V4-Pro-0813": {
			id: "deepseek-ai/DeepSeek-V4-Pro-0813",
			name: "DeepSeek V4 Pro 0813",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.32,
				output: 3.96,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-ai/DeepSeek-V4.1-Flash": {
			id: "deepseek-ai/DeepSeek-V4.1-Flash",
			name: "DeepSeek V4.1 Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"google/gemma-3-12b-it": {
			id: "google/gemma-3-12b-it",
			name: "Gemma 3 12B IT",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.05,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"google/gemma-3-27b-it": {
			id: "google/gemma-3-27b-it",
			name: "Gemma 3 27B IT",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.08,
				output: 0.16,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"google/gemma-3-4b-it": {
			id: "google/gemma-3-4b-it",
			name: "Gemma 3 4B IT",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.05,
				output: 0.1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"google/gemma-4-26B-A4B-it": {
			id: "google/gemma-4-26B-A4B-it",
			name: "Gemma 4 26B A4B IT",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.13,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"google/gemma-4-31B-it": {
			id: "google/gemma-4-31B-it",
			name: "Gemma 4 31B IT",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"meta-llama/Llama-3.1-8B-Instruct": {
			id: "meta-llama/Llama-3.1-8B-Instruct",
			name: "Llama-3.1-8B-Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.06,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"meta-llama/Llama-3.3-70B-Instruct": {
			id: "meta-llama/Llama-3.3-70B-Instruct",
			name: "Llama-3.3-70B-Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.59,
				output: 0.79,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K2-Instruct": {
			id: "moonshotai/Kimi-K2-Instruct",
			name: "Kimi-K2-Instruct",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K2-Instruct-0905": {
			id: "moonshotai/Kimi-K2-Instruct-0905",
			name: "Kimi-K2-Instruct-0905",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K2-Thinking": {
			id: "moonshotai/Kimi-K2-Thinking",
			name: "Kimi-K2-Thinking",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K2.5": {
			id: "moonshotai/Kimi-K2.5",
			name: "Kimi-K2.5",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3,
				cacheRead: 0.1,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K2.6": {
			id: "moonshotai/Kimi-K2.6",
			name: "Kimi-K2.6",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.16,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K2.7-Code": {
			id: "moonshotai/Kimi-K2.7-Code",
			name: "Kimi K2.7 Code",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"moonshotai/Kimi-K3": {
			id: "moonshotai/Kimi-K3",
			name: "Kimi K3",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-120b": {
			id: "openai/gpt-oss-120b",
			name: "GPT OSS 120B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.69,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-20b": {
			id: "openai/gpt-oss-20b",
			name: "GPT OSS 20B",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"stepfun-ai/Step-3.5-Flash": {
			id: "stepfun-ai/Step-3.5-Flash",
			name: "Step 3.5 Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"openai-completions">,
		"stepfun-ai/Step-3.7-Flash": {
			id: "stepfun-ai/Step-3.7-Flash",
			name: "Step 3.7 Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"openai-completions">,
		"tencent/Hy3": {
			id: "tencent/Hy3",
			name: "Hy3",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.14,
				output: 0.58,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"tencent/Hy4-preview": {
			id: "tencent/Hy4-preview",
			name: "Hy4 preview",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.834,
				output: 2.501,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"thinkingmachines/Inkling": {
			id: "thinkingmachines/Inkling",
			name: "Inkling",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 4.05,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"openai-completions">,
		"thinkingmachines/Inkling-Small": {
			id: "thinkingmachines/Inkling-Small",
			name: "Inkling Small",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 1048576,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.5": {
			id: "zai-org/GLM-4.5",
			name: "GLM-4.5",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 98304,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.5-Air": {
			id: "zai-org/GLM-4.5-Air",
			name: "GLM-4.5-Air",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.13,
				output: 0.85,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 98304,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.5V": {
			id: "zai-org/GLM-4.5V",
			name: "GLM-4.5V",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 1.8,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 65536,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.6": {
			id: "zai-org/GLM-4.6",
			name: "GLM-4.6",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.55,
				output: 2.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.6V-Flash": {
			id: "zai-org/GLM-4.6V-Flash",
			name: "GLM-4.6V-Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 0.9,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.7": {
			id: "zai-org/GLM-4.7",
			name: "GLM-4.7",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-4.7-Flash": {
			id: "zai-org/GLM-4.7-Flash",
			name: "GLM-4.7-Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-5": {
			id: "zai-org/GLM-5",
			name: "GLM-5",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1,
				output: 3.2,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-5.1": {
			id: "zai-org/GLM-5.1",
			name: "GLM-5.1",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1,
				output: 3.2,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-5.2": {
			id: "zai-org/GLM-5.2",
			name: "GLM-5.2",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-5.3": {
			id: "zai-org/GLM-5.3",
			name: "GLM-5.3",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"zai-org/GLM-5.3-Flash": {
			id: "zai-org/GLM-5.3-Flash",
			name: "GLM-5.3-Flash",
			api: "openai-completions",
			provider: "huggingface",
			baseUrl: "https://router.huggingface.co/v1",
			compat: {"supportsDeveloperRole":false},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
	},
	"kimi-coding": {
		"k2p5": {
			id: "k2p5",
			name: "Kimi K2.5",
			api: "anthropic-messages",
			provider: "kimi-coding",
			baseUrl: "https://api.kimi.com/coding",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"kimi-k2-thinking": {
			id: "kimi-k2-thinking",
			name: "Kimi K2 Thinking",
			api: "anthropic-messages",
			provider: "kimi-coding",
			baseUrl: "https://api.kimi.com/coding",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
	},
	"kimi-coding-oauth": {
		"k3": {
			id: "k3",
			name: "Kimi K3",
			api: "openai-completions",
			provider: "kimi-coding-oauth",
			baseUrl: "https://api.kimi.com/coding/v1",
			compat: {"thinkingFormat":"kimi","supportsDeveloperRole":false,"reasoningEffortMap":{"minimal":"low","low":"low","medium":"high","high":"high","xhigh":"max"}},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"kimi-for-coding": {
			id: "kimi-for-coding",
			name: "Kimi For Coding",
			api: "openai-completions",
			provider: "kimi-coding-oauth",
			baseUrl: "https://api.kimi.com/coding/v1",
			compat: {"thinkingFormat":"kimi","supportsDeveloperRole":false,"reasoningEffortMap":{"minimal":"auto","low":"auto","medium":"auto","high":"auto","xhigh":"auto"}},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"kimi-for-coding-highspeed": {
			id: "kimi-for-coding-highspeed",
			name: "Kimi For Coding Highspeed",
			api: "openai-completions",
			provider: "kimi-coding-oauth",
			baseUrl: "https://api.kimi.com/coding/v1",
			compat: {"thinkingFormat":"kimi","supportsDeveloperRole":false,"reasoningEffortMap":{"minimal":"auto","low":"auto","medium":"auto","high":"auto","xhigh":"auto"}},
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
	},
	"minimax": {
		"MiniMax-M2.7": {
			id: "MiniMax-M2.7",
			name: "MiniMax-M2.7",
			api: "anthropic-messages",
			provider: "minimax",
			baseUrl: "https://api.minimax.io/anthropic",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"MiniMax-M2.7-highspeed": {
			id: "MiniMax-M2.7-highspeed",
			name: "MiniMax-M2.7-highspeed",
			api: "anthropic-messages",
			provider: "minimax",
			baseUrl: "https://api.minimax.io/anthropic",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.4,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
	},
	"minimax-cn": {
		"MiniMax-M2.7": {
			id: "MiniMax-M2.7",
			name: "MiniMax-M2.7",
			api: "anthropic-messages",
			provider: "minimax-cn",
			baseUrl: "https://api.minimaxi.com/anthropic",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"MiniMax-M2.7-highspeed": {
			id: "MiniMax-M2.7-highspeed",
			name: "MiniMax-M2.7-highspeed",
			api: "anthropic-messages",
			provider: "minimax-cn",
			baseUrl: "https://api.minimaxi.com/anthropic",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.4,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
	},
	"mistral": {
		"codestral-2508": {
			id: "codestral-2508",
			name: "Codestral 25.08",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 0.9,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 8192,
		} satisfies Model<"mistral-conversations">,
		"codestral-latest": {
			id: "codestral-latest",
			name: "Codestral (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 0.9,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 4096,
		} satisfies Model<"mistral-conversations">,
		"devstral-2512": {
			id: "devstral-2512",
			name: "Devstral 2",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"devstral-latest": {
			id: "devstral-latest",
			name: "Devstral 2",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"devstral-medium-2507": {
			id: "devstral-medium-2507",
			name: "Devstral Medium",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"devstral-medium-latest": {
			id: "devstral-medium-latest",
			name: "Devstral 2 (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"devstral-small-2505": {
			id: "devstral-small-2505",
			name: "Devstral Small 2505",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"devstral-small-2507": {
			id: "devstral-small-2507",
			name: "Devstral Small",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"glm-5-2": {
			id: "glm-5-2",
			name: "GLM-5.2",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.14,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"mistral-conversations">,
		"labs-devstral-small-2512": {
			id: "labs-devstral-small-2512",
			name: "Devstral Small 2",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"mistral-conversations">,
		"labs-leanstral-1-5-1": {
			id: "labs-leanstral-1-5-1",
			name: "Leanstral 1.5",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"magistral-medium-latest": {
			id: "magistral-medium-latest",
			name: "Magistral Medium (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"mistral-conversations">,
		"ministral-14b-2512": {
			id: "ministral-14b-2512",
			name: "Ministral 3 14B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 0.2,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"ministral-3b-2512": {
			id: "ministral-3b-2512",
			name: "Ministral 3 3B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.1,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"ministral-3b-latest": {
			id: "ministral-3b-latest",
			name: "Ministral 3B (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.04,
				output: 0.04,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"ministral-8b-2512": {
			id: "ministral-8b-2512",
			name: "Ministral 3 8B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"ministral-8b-latest": {
			id: "ministral-8b-latest",
			name: "Ministral 8B (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"mistral-large-2411": {
			id: "mistral-large-2411",
			name: "Mistral Large 2.1",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"mistral-conversations">,
		"mistral-large-2512": {
			id: "mistral-large-2512",
			name: "Mistral Large 3",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0.05,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"mistral-large-4": {
			id: "mistral-large-4",
			name: "Mistral Large 4",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.68,
				output: 2.09,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"mistral-large-latest": {
			id: "mistral-large-latest",
			name: "Mistral Large (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0.05,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"mistral-medium-2505": {
			id: "mistral-medium-2505",
			name: "Mistral Medium 3",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"mistral-conversations">,
		"mistral-medium-2508": {
			id: "mistral-medium-2508",
			name: "Mistral Medium 3.1",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"mistral-medium-2604": {
			id: "mistral-medium-2604",
			name: "Mistral Medium 3.5",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"mistral-medium-latest": {
			id: "mistral-medium-latest",
			name: "Mistral Medium (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"mistral-conversations">,
		"mistral-nemo": {
			id: "mistral-nemo",
			name: "Mistral Nemo",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"mistral-small-2506": {
			id: "mistral-small-2506",
			name: "Mistral Small 3.2",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"mistral-conversations">,
		"mistral-small-2603": {
			id: "mistral-small-2603",
			name: "Mistral Small 4",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"mistral-conversations">,
		"mistral-small-latest": {
			id: "mistral-small-latest",
			name: "Mistral Small (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"mistral-conversations">,
		"open-mistral-7b": {
			id: "open-mistral-7b",
			name: "Mistral 7B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.25,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 8000,
			maxTokens: 8000,
		} satisfies Model<"mistral-conversations">,
		"open-mistral-nemo": {
			id: "open-mistral-nemo",
			name: "Open Mistral Nemo",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"open-mixtral-8x22b": {
			id: "open-mixtral-8x22b",
			name: "Mixtral 8x22B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 64000,
			maxTokens: 64000,
		} satisfies Model<"mistral-conversations">,
		"open-mixtral-8x7b": {
			id: "open-mixtral-8x7b",
			name: "Mixtral 8x7B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.7,
				output: 0.7,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32000,
			maxTokens: 32000,
		} satisfies Model<"mistral-conversations">,
		"pixtral-12b": {
			id: "pixtral-12b",
			name: "Pixtral 12B",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"pixtral-large-latest": {
			id: "pixtral-large-latest",
			name: "Pixtral Large (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"mistral-conversations">,
		"voxtral-small-2507": {
			id: "voxtral-small-2507",
			name: "Voxtral Small",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 32000,
		} satisfies Model<"mistral-conversations">,
		"voxtral-small-latest": {
			id: "voxtral-small-latest",
			name: "Voxtral Small (latest)",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.1,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 32000,
		} satisfies Model<"mistral-conversations">,
		"zai-glm-5-2": {
			id: "zai-glm-5-2",
			name: "GLM-5.2",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.14,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"mistral-conversations">,
		"zai-glm-5-3": {
			id: "zai-glm-5-3",
			name: "GLM-5.3",
			api: "mistral-conversations",
			provider: "mistral",
			baseUrl: "https://api.mistral.ai",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.14,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"mistral-conversations">,
	},
	"openai": {
		"gpt-4": {
			id: "gpt-4",
			name: "GPT-4",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 30,
				output: 60,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 8192,
			maxTokens: 8192,
		} satisfies Model<"openai-responses">,
		"gpt-4-turbo": {
			id: "gpt-4-turbo",
			name: "GPT-4 Turbo",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 30,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"openai-responses">,
		"gpt-4.1": {
			id: "gpt-4.1",
			name: "GPT-4.1",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-responses">,
		"gpt-4.1-mini": {
			id: "gpt-4.1-mini",
			name: "GPT-4.1 mini",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 1.6,
				cacheRead: 0.1,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-responses">,
		"gpt-4.1-nano": {
			id: "gpt-4.1-nano",
			name: "GPT-4.1 nano",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.4,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-responses">,
		"gpt-4o": {
			id: "gpt-4o",
			name: "GPT-4o",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-4o-2024-05-13": {
			id: "gpt-4o-2024-05-13",
			name: "GPT-4o (2024-05-13)",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"openai-responses">,
		"gpt-4o-2024-08-06": {
			id: "gpt-4o-2024-08-06",
			name: "GPT-4o (2024-08-06)",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-4o-2024-11-20": {
			id: "gpt-4o-2024-11-20",
			name: "GPT-4o (2024-11-20)",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-4o-mini": {
			id: "gpt-4o-mini",
			name: "GPT-4o mini",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-5": {
			id: "gpt-5",
			name: "GPT-5",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5-chat-latest": {
			id: "gpt-5-chat-latest",
			name: "GPT-5 Chat Latest",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-5-mini": {
			id: "gpt-5-mini",
			name: "GPT-5 Mini",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5-nano": {
			id: "gpt-5-nano",
			name: "GPT-5 Nano",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.05,
				output: 0.4,
				cacheRead: 0.005,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5-pro": {
			id: "gpt-5-pro",
			name: "GPT-5 Pro",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 120,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 272000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1": {
			id: "gpt-5.1",
			name: "GPT-5.1",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1-codex": {
			id: "gpt-5.1-codex",
			name: "GPT-5.1 Codex",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 5,
				cacheRead: 0.125,
				cacheWrite: 1.25,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1-codex-max": {
			id: "gpt-5.1-codex-max",
			name: "GPT-5.1 Codex Max",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.2": {
			id: "gpt-5.2",
			name: "GPT-5.2",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.2-chat-latest": {
			id: "gpt-5.2-chat-latest",
			name: "GPT-5.2 Chat",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-5.2-pro": {
			id: "gpt-5.2-pro",
			name: "GPT-5.2 Pro",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 21,
				output: 168,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.3-chat-latest": {
			id: "gpt-5.3-chat-latest",
			name: "GPT-5.3 Chat (latest)",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-responses">,
		"gpt-5.3-codex": {
			id: "gpt-5.3-codex",
			name: "GPT-5.3 Codex",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.3-codex-spark": {
			id: "gpt-5.3-codex-spark",
			name: "GPT-5.3 Codex Spark",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 32000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4": {
			id: "gpt-5.4",
			name: "GPT-5.4",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-mini": {
			id: "gpt-5.4-mini",
			name: "GPT-5.4 mini",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-nano": {
			id: "gpt-5.4-nano",
			name: "GPT-5.4 nano",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.25,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-pro": {
			id: "gpt-5.4-pro",
			name: "GPT-5.4 Pro",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.5": {
			id: "gpt-5.5",
			name: "GPT-5.5",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.5-pro": {
			id: "gpt-5.5-pro",
			name: "GPT-5.5 Pro",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6": {
			id: "gpt-5.6",
			name: "GPT-5.6",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-luna": {
			id: "gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-sol": {
			id: "gpt-5.6-sol",
			name: "GPT-5.6 Sol",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-terra": {
			id: "gpt-5.6-terra",
			name: "GPT-5.6 Terra",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-astra": {
			id: "gpt-6-astra",
			name: "GPT-6 Astra",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-luna": {
			id: "gpt-6-luna",
			name: "GPT-6 Luna",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-sol": {
			id: "gpt-6-sol",
			name: "GPT-6 Sol",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6.1-sol": {
			id: "gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-daybreak-blue-latest": {
			id: "gpt-daybreak-blue-latest",
			name: "Daybreak Blue",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-daybreak-red-latest": {
			id: "gpt-daybreak-red-latest",
			name: "Daybreak Red",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 12.5,
				output: 75,
				cacheRead: 1.25,
				cacheWrite: 15.625,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-realtime-2.1": {
			id: "gpt-realtime-2.1",
			name: "GPT-Realtime-2.1",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 24,
				cacheRead: 0.4,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 32000,
		} satisfies Model<"openai-responses">,
		"o1": {
			id: "o1",
			name: "o1",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 60,
				cacheRead: 7.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-responses">,
		"o1-pro": {
			id: "o1-pro",
			name: "o1-pro",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 150,
				output: 600,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-responses">,
		"o3": {
			id: "o3",
			name: "o3",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-responses">,
		"o3-mini": {
			id: "o3-mini",
			name: "o3-mini",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-responses">,
		"o3-pro": {
			id: "o3-pro",
			name: "o3-pro",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 20,
				output: 80,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-responses">,
		"o4-mini": {
			id: "o4-mini",
			name: "o4-mini",
			api: "openai-responses",
			provider: "openai",
			baseUrl: "https://api.openai.com/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-responses">,
	},
	"openai-codex": {
		"gpt-5.4-mini": {
			id: "gpt-5.4-mini",
			name: "GPT-5.4 mini",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-5.5": {
			id: "gpt-5.5",
			name: "GPT-5.5",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-5.6-luna": {
			id: "gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-5.6-sol": {
			id: "gpt-5.6-sol",
			name: "GPT-5.6 Sol",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-5.6-terra": {
			id: "gpt-5.6-terra",
			name: "GPT-5.6 Terra",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-6-astra": {
			id: "gpt-6-astra",
			name: "GPT-6 Astra",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-6-luna": {
			id: "gpt-6-luna",
			name: "GPT-6 Luna",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-6-sol": {
			id: "gpt-6-sol",
			name: "GPT-6 Sol",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-6.1-sol": {
			id: "gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-daybreak-blue-latest": {
			id: "gpt-daybreak-blue-latest",
			name: "Daybreak Blue",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
		"gpt-daybreak-red-latest": {
			id: "gpt-daybreak-red-latest",
			name: "Daybreak Red",
			api: "openai-codex-responses",
			provider: "openai-codex",
			baseUrl: "https://chatgpt.com/backend-api",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 12.5,
				output: 75,
				cacheRead: 1.25,
				cacheWrite: 15.625,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-codex-responses">,
	},
	"opencode": {
		"big-pickle": {
			id: "big-pickle",
			name: "Big Pickle",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"claude-fable-5": {
			id: "claude-fable-5",
			name: "Claude Fable 5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-fable-5-1": {
			id: "claude-fable-5-1",
			name: "Claude Fable 5.1",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-haiku-4-5": {
			id: "claude-haiku-4-5",
			name: "Claude Haiku 4.5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.1,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-haiku-5-5": {
			id: "claude-haiku-5-5",
			name: "Claude Haiku 5.5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-5": {
			id: "claude-opus-4-5",
			name: "Claude Opus 4.5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-6": {
			id: "claude-opus-4-6",
			name: "Claude Opus 4.6",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-7": {
			id: "claude-opus-4-7",
			name: "Claude Opus 4.7",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-4-8": {
			id: "claude-opus-4-8",
			name: "Claude Opus 4.8",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-5": {
			id: "claude-opus-5",
			name: "Claude Opus 5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-opus-5-5": {
			id: "claude-opus-5-5",
			name: "Claude Opus 5.5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.2,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-4": {
			id: "claude-sonnet-4",
			name: "Claude Sonnet 4",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-4-5": {
			id: "claude-sonnet-4-5",
			name: "Claude Sonnet 4.5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-4-6": {
			id: "claude-sonnet-4-6",
			name: "Claude Sonnet 4.6",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-5": {
			id: "claude-sonnet-5",
			name: "Claude Sonnet 5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"claude-sonnet-5-5": {
			id: "claude-sonnet-5-5",
			name: "Claude Sonnet 5.5",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"deepseek-v4-flash": {
			id: "deepseek-v4-flash",
			name: "DeepSeek V4 Flash",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.028,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-v4-flash-vision-exp": {
			id: "deepseek-v4-flash-vision-exp",
			name: "DeepSeek V4 Flash Vision Exp",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.028,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-v4-pro": {
			id: "deepseek-v4-pro",
			name: "DeepSeek V4 Pro",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.74,
				output: 3.84,
				cacheRead: 0.145,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-v4.1-flash": {
			id: "deepseek-v4.1-flash",
			name: "DeepSeek V4.1 Flash",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.006,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"exo-free": {
			id: "exo-free",
			name: "Exo Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"gemini-3-flash": {
			id: "gemini-3-flash",
			name: "Gemini 3 Flash",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.05,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.1-pro": {
			id: "gemini-3.1-pro",
			name: "Gemini 3.1 Pro Preview",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.5-flash": {
			id: "gemini-3.5-flash",
			name: "Gemini 3.5 Flash",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 9,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.5-flash-lite": {
			id: "gemini-3.5-flash-lite",
			name: "Gemini 3.5 Flash Lite",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.6-flash": {
			id: "gemini-3.6-flash",
			name: "Gemini 3.6 Flash",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.7-flash": {
			id: "gemini-3.7-flash",
			name: "Gemini 3.7 Flash",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"gemini-3.8-flash": {
			id: "gemini-3.8-flash",
			name: "Gemini 3.8 Flash",
			api: "google-generative-ai",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"google-generative-ai">,
		"glm-5": {
			id: "glm-5",
			name: "GLM-5",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1,
				output: 3.2,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"glm-5.1": {
			id: "glm-5.1",
			name: "GLM-5.1",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.26,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"glm-5.2": {
			id: "glm-5.2",
			name: "GLM-5.2",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.26,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"glm-5.3": {
			id: "glm-5.3",
			name: "GLM-5.3",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.26,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"glm-5.3-flash": {
			id: "glm-5.3-flash",
			name: "GLM-5.3-Flash",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"gpt-5": {
			id: "gpt-5",
			name: "GPT-5",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.07,
				output: 8.5,
				cacheRead: 0.107,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5-codex": {
			id: "gpt-5-codex",
			name: "GPT-5 Codex",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.07,
				output: 8.5,
				cacheRead: 0.107,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5-nano": {
			id: "gpt-5-nano",
			name: "GPT-5 Nano",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.05,
				output: 0.4,
				cacheRead: 0.005,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1": {
			id: "gpt-5.1",
			name: "GPT-5.1",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.07,
				output: 8.5,
				cacheRead: 0.107,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1-codex": {
			id: "gpt-5.1-codex",
			name: "GPT-5.1 Codex",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.07,
				output: 8.5,
				cacheRead: 0.107,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1-codex-max": {
			id: "gpt-5.1-codex-max",
			name: "GPT-5.1 Codex Max",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.1-codex-mini": {
			id: "gpt-5.1-codex-mini",
			name: "GPT-5.1 Codex Mini",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.025,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.2": {
			id: "gpt-5.2",
			name: "GPT-5.2",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.2-codex": {
			id: "gpt-5.2-codex",
			name: "GPT-5.2 Codex",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.3-codex": {
			id: "gpt-5.3-codex",
			name: "GPT-5.3 Codex",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4": {
			id: "gpt-5.4",
			name: "GPT-5.4",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 272000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-mini": {
			id: "gpt-5.4-mini",
			name: "GPT-5.4 Mini",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-nano": {
			id: "gpt-5.4-nano",
			name: "GPT-5.4 Nano",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.25,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.4-pro": {
			id: "gpt-5.4-pro",
			name: "GPT-5.4 Pro",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 30,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.5": {
			id: "gpt-5.5",
			name: "GPT-5.5",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.5-pro": {
			id: "gpt-5.5-pro",
			name: "GPT-5.5 Pro",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 30,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-luna": {
			id: "gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-sol": {
			id: "gpt-5.6-sol",
			name: "GPT-5.6 Sol",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.4,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-5.6-terra": {
			id: "gpt-5.6-terra",
			name: "GPT-5.6 Terra",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 3.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-astra": {
			id: "gpt-6-astra",
			name: "GPT-6 Astra",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-luna": {
			id: "gpt-6-luna",
			name: "GPT-6 Luna",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-sol": {
			id: "gpt-6-sol",
			name: "GPT-6 Sol",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.2,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6.1-sol": {
			id: "gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.1,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"grok-4.5": {
			id: "grok-4.5",
			name: "Grok 4.5",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-responses">,
		"grok-4.6": {
			id: "grok-4.6",
			name: "Grok 4.6",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-responses">,
		"grok-4.7": {
			id: "grok-4.7",
			name: "Grok 4.7",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-responses">,
		"grok-build-0.1": {
			id: "grok-build-0.1",
			name: "Grok Build 0.1",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 2,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"openai-responses">,
		"kimi-k2.5": {
			id: "kimi-k2.5",
			name: "Kimi K2.5",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3,
				cacheRead: 0.08,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"kimi-k2.6": {
			id: "kimi-k2.6",
			name: "Kimi K2.6",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.16,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"kimi-k2.7-code": {
			id: "kimi-k2.7-code",
			name: "Kimi K2.7 Code",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.19,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"kimi-k3": {
			id: "kimi-k3",
			name: "Kimi K3",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"ling-3.0-flash-fin-free": {
			id: "ling-3.0-flash-fin-free",
			name: "Ling 3.0 Flash Fin Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"ling-3.1-flash-free": {
			id: "ling-3.1-flash-free",
			name: "Ling 3.1 Flash Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"longcat-2.5-preview-free": {
			id: "longcat-2.5-preview-free",
			name: "LongCat 2.5 Preview Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"mimo-v2.6-flash-free": {
			id: "mimo-v2.6-flash-free",
			name: "MiMo-V2.6-Flash Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"minimax-m2.5": {
			id: "minimax-m2.5",
			name: "MiniMax-M2.5",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"minimax-m2.7": {
			id: "minimax-m2.7",
			name: "MiniMax-M2.7",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"minimax-m3": {
			id: "minimax-m3",
			name: "MiniMax-M3",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 512000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"mistral-large-4": {
			id: "mistral-large-4",
			name: "Mistral Large 4",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.68,
				output: 2.09,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"muse-spark-1.2": {
			id: "muse-spark-1.2",
			name: "Muse Spark 1.2",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-responses">,
		"muse-spark-1.3": {
			id: "muse-spark-1.3",
			name: "Muse Spark 1.3",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-responses">,
		"muse-spark-1.3-contributor-free": {
			id: "muse-spark-1.3-contributor-free",
			name: "Muse Spark 1.3 Free",
			api: "openai-responses",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-responses">,
		"nemotron-3-ultra-free": {
			id: "nemotron-3-ultra-free",
			name: "Nemotron 3 Ultra Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"nemotron-3.5-lightning-free": {
			id: "nemotron-3.5-lightning-free",
			name: "Nemotron 3.5 Lightning Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"qwen3.5-plus": {
			id: "qwen3.5-plus",
			name: "Qwen3.5 Plus",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"qwen3.6-plus": {
			id: "qwen3.6-plus",
			name: "Qwen3.6 Plus",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.05,
				cacheWrite: 0.625,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"qwen3.8-flash": {
			id: "qwen3.8-flash",
			name: "Qwen3.8 Flash",
			api: "anthropic-messages",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.47,
				cacheRead: 0.016,
				cacheWrite: 0.2,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"qwen3.8-max": {
			id: "qwen3.8-max",
			name: "Qwen3.8 Max",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 2.5,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"space-bunny-free": {
			id: "space-bunny-free",
			name: "Space Bunny Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 524288,
		} satisfies Model<"openai-completions">,
		"step-5-preview-free": {
			id: "step-5-preview-free",
			name: "Step 5 Preview Free",
			api: "openai-completions",
			provider: "opencode",
			baseUrl: "https://opencode.ai/zen/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
	},
	"opencode-go": {
		"claude-haiku-5-5": {
			id: "claude-haiku-5-5",
			name: "Claude Haiku 5.5",
			api: "anthropic-messages",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"deepseek-v4-flash": {
			id: "deepseek-v4-flash",
			name: "DeepSeek V4 Flash",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.003,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-v4-flash-vision-exp": {
			id: "deepseek-v4-flash-vision-exp",
			name: "DeepSeek V4 Flash Vision Exp",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.003,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-v4-pro": {
			id: "deepseek-v4-pro",
			name: "DeepSeek V4 Pro (New)",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.66,
				output: 1.98,
				cacheRead: 0.022,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek-v4.1-flash": {
			id: "deepseek-v4.1-flash",
			name: "DeepSeek V4.1 Flash",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.003,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"glm-5.2": {
			id: "glm-5.2",
			name: "GLM-5.2",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.26,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"glm-5.3": {
			id: "glm-5.3",
			name: "GLM-5.3",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.26,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"glm-5.3-flash": {
			id: "glm-5.3-flash",
			name: "GLM-5.3-Flash",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"gpt-5.6-luna": {
			id: "gpt-5.6-luna",
			name: "GPT-5.6 Luna",
			api: "openai-responses",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.2,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"gpt-6-luna": {
			id: "gpt-6-luna",
			name: "GPT-6 Luna",
			api: "openai-responses",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-responses">,
		"grok-4.6": {
			id: "grok-4.6",
			name: "Grok 4.6",
			api: "openai-responses",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-responses">,
		"grok-4.7": {
			id: "grok-4.7",
			name: "Grok 4.7",
			api: "openai-responses",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-responses">,
		"hy3": {
			id: "hy3",
			name: "Hy3",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.14,
				output: 0.58,
				cacheRead: 0.035,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"hy4-preview": {
			id: "hy4-preview",
			name: "Hy4 preview",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.834,
				output: 2.501,
				cacheRead: 0.042,
				cacheWrite: 0,
			},
			contextWindow: 1024000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"kimi-k2.7-code": {
			id: "kimi-k2.7-code",
			name: "Kimi K2.7 Code",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.19,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"kimi-k3": {
			id: "kimi-k3",
			name: "Kimi K3",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"longcat-2.0": {
			id: "longcat-2.0",
			name: "LongCat-2.0",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.006,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"longcat-2.5-preview-free": {
			id: "longcat-2.5-preview-free",
			name: "LongCat 2.5 Preview Free",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"mimo-v2.5": {
			id: "mimo-v2.5",
			name: "MiMo V2.5",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.0028,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"mimo-v2.5-pro": {
			id: "mimo-v2.5-pro",
			name: "MiMo V2.5 Pro",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.003625,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"mimo-v2.6-flash": {
			id: "mimo-v2.6-flash",
			name: "MiMo-V2.6-Flash",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.0028,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"mimo-v2.6-pro": {
			id: "mimo-v2.6-pro",
			name: "MiMo-V2.6-Pro",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.003625,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"minimax-m2.7": {
			id: "minimax-m2.7",
			name: "MiniMax-M2.7",
			api: "anthropic-messages",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"minimax-m3": {
			id: "minimax-m3",
			name: "MiniMax-M3",
			api: "anthropic-messages",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"muse-spark-1.2-contributor": {
			id: "muse-spark-1.2-contributor",
			name: "Muse Spark 1.2 Contributor",
			api: "openai-responses",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.2,
				cacheRead: 0.002,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-responses">,
		"muse-spark-1.3-contributor": {
			id: "muse-spark-1.3-contributor",
			name: "Muse Spark 1.3 Contributor",
			api: "openai-responses",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1,
				output: 0.2,
				cacheRead: 0.002,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-responses">,
		"qwen3.7-plus": {
			id: "qwen3.7-plus",
			name: "Qwen3.7 Plus",
			api: "anthropic-messages",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.4,
				output: 1.6,
				cacheRead: 0.04,
				cacheWrite: 0.5,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"qwen3.8-flash": {
			id: "qwen3.8-flash",
			name: "Qwen3.8 Flash",
			api: "anthropic-messages",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.47,
				cacheRead: 0.016,
				cacheWrite: 0.2,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"qwen3.8-max": {
			id: "qwen3.8-max",
			name: "Qwen3.8 Max",
			api: "anthropic-messages",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"space-bunny": {
			id: "space-bunny",
			name: "Space Bunny",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 524288,
		} satisfies Model<"openai-completions">,
		"step-5-preview-free": {
			id: "step-5-preview-free",
			name: "Step 5 Preview Free",
			api: "openai-completions",
			provider: "opencode-go",
			baseUrl: "https://opencode.ai/zen/go/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
	},
	"openrouter": {
		"aion-labs/aion-2.0": {
			id: "aion-labs/aion-2.0",
			name: "AionLabs: Aion-2.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7999999999999999,
				output: 1.5999999999999999,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"aion-labs/aion-3.0": {
			id: "aion-labs/aion-3.0",
			name: "AionLabs: Aion-3.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 3,
				output: 6,
				cacheRead: 0.75,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"aion-labs/aion-3.0-mini": {
			id: "aion-labs/aion-3.0-mini",
			name: "AionLabs: Aion-3.0-Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7,
				output: 1.4,
				cacheRead: 0.18,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"aion-labs/aion-3.5": {
			id: "aion-labs/aion-3.5",
			name: "AionLabs: Aion 3.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 3,
				output: 6,
				cacheRead: 0.75,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"aion-labs/aion-3.5-mini": {
			id: "aion-labs/aion-3.5-mini",
			name: "AionLabs: Aion 3.5 Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7,
				output: 1.4,
				cacheRead: 0.18,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"amazon/nova-2-lite-v1": {
			id: "amazon/nova-2-lite-v1",
			name: "Amazon: Nova 2 Lite",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"openai-completions">,
		"amazon/nova-lite-v1": {
			id: "amazon/nova-lite-v1",
			name: "Amazon: Nova Lite 1.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.06,
				output: 0.24,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 300000,
			maxTokens: 5120,
		} satisfies Model<"openai-completions">,
		"amazon/nova-micro-v1": {
			id: "amazon/nova-micro-v1",
			name: "Amazon: Nova Micro 1.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.035,
				output: 0.14,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 5120,
		} satisfies Model<"openai-completions">,
		"amazon/nova-premier-v1": {
			id: "amazon/nova-premier-v1",
			name: "Amazon: Nova Premier 1.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.625,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"amazon/nova-pro-v1": {
			id: "amazon/nova-pro-v1",
			name: "Amazon: Nova Pro 1.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.7999999999999999,
				output: 3.1999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 300000,
			maxTokens: 5120,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-fable-5": {
			id: "anthropic/claude-fable-5",
			name: "Anthropic: Claude Fable 5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-fable-5.1": {
			id: "anthropic/claude-fable-5.1",
			name: "Anthropic: Claude Fable 5.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-fable-5.1:batch": {
			id: "anthropic/claude-fable-5.1:batch",
			name: "Anthropic: Claude Fable 5.1 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.125,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-fable-5:batch": {
			id: "anthropic/claude-fable-5:batch",
			name: "Anthropic: Claude Fable 5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-haiku-4.5": {
			id: "anthropic/claude-haiku-4.5",
			name: "Anthropic: Claude Haiku 4.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-haiku-4.5:batch": {
			id: "anthropic/claude-haiku-4.5:batch",
			name: "Anthropic: Claude Haiku 4.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 2.5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0.625,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-haiku-5.5": {
			id: "anthropic/claude-haiku-5.5",
			name: "Anthropic: Claude Haiku 5.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-haiku-5.5:batch": {
			id: "anthropic/claude-haiku-5.5:batch",
			name: "Anthropic: Claude Haiku 5.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.25,
				cacheRead: 0.005,
				cacheWrite: 0.0625,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.1": {
			id: "anthropic/claude-opus-4.1",
			name: "Anthropic: Claude Opus 4.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 75,
				cacheRead: 1.5,
				cacheWrite: 18.75,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.1:batch": {
			id: "anthropic/claude-opus-4.1:batch",
			name: "Anthropic: Claude Opus 4.1 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 7.5,
				output: 37.5,
				cacheRead: 0.75,
				cacheWrite: 9.375,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.5": {
			id: "anthropic/claude-opus-4.5",
			name: "Anthropic: Claude Opus 4.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.5:batch": {
			id: "anthropic/claude-opus-4.5:batch",
			name: "Anthropic: Claude Opus 4.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.25,
				cacheWrite: 3.125,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.6": {
			id: "anthropic/claude-opus-4.6",
			name: "Anthropic: Claude Opus 4.6",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.6:batch": {
			id: "anthropic/claude-opus-4.6:batch",
			name: "Anthropic: Claude Opus 4.6 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.25,
				cacheWrite: 3.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.7": {
			id: "anthropic/claude-opus-4.7",
			name: "Anthropic: Claude Opus 4.7",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.7:batch": {
			id: "anthropic/claude-opus-4.7:batch",
			name: "Anthropic: Claude Opus 4.7 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.25,
				cacheWrite: 3.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.8": {
			id: "anthropic/claude-opus-4.8",
			name: "Anthropic: Claude Opus 4.8",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-4.8:batch": {
			id: "anthropic/claude-opus-4.8:batch",
			name: "Anthropic: Claude Opus 4.8 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.25,
				cacheWrite: 3.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-5": {
			id: "anthropic/claude-opus-5",
			name: "Anthropic: Claude Opus 5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-5.5": {
			id: "anthropic/claude-opus-5.5",
			name: "Anthropic: Claude Opus 5.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.19999999999999998,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-5.5:batch": {
			id: "anthropic/claude-opus-5.5:batch",
			name: "Anthropic: Claude Opus 5.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-opus-5:batch": {
			id: "anthropic/claude-opus-5:batch",
			name: "Anthropic: Claude Opus 5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 12.5,
				cacheRead: 0.25,
				cacheWrite: 3.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-4": {
			id: "anthropic/claude-sonnet-4",
			name: "Anthropic: Claude Sonnet 4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-4.5": {
			id: "anthropic/claude-sonnet-4.5",
			name: "Anthropic: Claude Sonnet 4.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-4.5:batch": {
			id: "anthropic/claude-sonnet-4.5:batch",
			name: "Anthropic: Claude Sonnet 4.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 1.875,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-4.6": {
			id: "anthropic/claude-sonnet-4.6",
			name: "Anthropic: Claude Sonnet 4.6",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-4.6:batch": {
			id: "anthropic/claude-sonnet-4.6:batch",
			name: "Anthropic: Claude Sonnet 4.6 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 1.875,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-5": {
			id: "anthropic/claude-sonnet-5",
			name: "Anthropic: Claude Sonnet 5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-5.5": {
			id: "anthropic/claude-sonnet-5.5",
			name: "Anthropic: Claude Sonnet 5.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-5.5:batch": {
			id: "anthropic/claude-sonnet-5.5:batch",
			name: "Anthropic: Claude Sonnet 5.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 1.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"anthropic/claude-sonnet-5:batch": {
			id: "anthropic/claude-sonnet-5:batch",
			name: "Anthropic: Claude Sonnet 5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"apodex/apodex-1.1-mini:free": {
			id: "apodex/apodex-1.1-mini:free",
			name: "Apodex: Apodex 1.1 Mini (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"arcee-ai/trinity-large-thinking": {
			id: "arcee-ai/trinity-large-thinking",
			name: "Arcee AI: Trinity Large Thinking",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.7999999999999999,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 80000,
		} satisfies Model<"openai-completions">,
		"auto": {
			id: "auto",
			name: "Auto",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 30000,
		} satisfies Model<"openai-completions">,
		"bytedance-seed/seed-1.6": {
			id: "bytedance-seed/seed-1.6",
			name: "ByteDance Seed: Seed 1.6",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"bytedance-seed/seed-1.6-flash": {
			id: "bytedance-seed/seed-1.6-flash",
			name: "ByteDance Seed: Seed 1.6 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"bytedance-seed/seed-2-1-turbo": {
			id: "bytedance-seed/seed-2-1-turbo",
			name: "ByteDance Seed: Seed 2.1 Turbo",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"bytedance-seed/seed-2.0-code": {
			id: "bytedance-seed/seed-2.0-code",
			name: "ByteDance Seed: Seed-2.0-Code",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"bytedance-seed/seed-2.0-lite": {
			id: "bytedance-seed/seed-2.0-lite",
			name: "ByteDance Seed: Seed-2.0-Lite",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"bytedance-seed/seed-2.0-mini": {
			id: "bytedance-seed/seed-2.0-mini",
			name: "ByteDance Seed: Seed-2.0-Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.39999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"cohere/command-a-plus": {
			id: "cohere/command-a-plus",
			name: "Cohere: Command A+",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 192000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"cohere/command-r-08-2024": {
			id: "cohere/command-r-08-2024",
			name: "Cohere: Command R (08-2024)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4000,
		} satisfies Model<"openai-completions">,
		"cohere/command-r-plus-08-2024": {
			id: "cohere/command-r-plus-08-2024",
			name: "Cohere: Command R+ (08-2024)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4000,
		} satisfies Model<"openai-completions">,
		"cohere/north-mini-code:free": {
			id: "cohere/north-mini-code:free",
			name: "Cohere: North Mini Code (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-chat": {
			id: "deepseek/deepseek-chat",
			name: "DeepSeek: DeepSeek V3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.32,
				output: 0.8899999999999999,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-chat-v3-0324": {
			id: "deepseek/deepseek-chat-v3-0324",
			name: "DeepSeek: DeepSeek V3 0324",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.29,
				output: 1.1400000000000001,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 115200,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-chat-v3.1": {
			id: "deepseek/deepseek-chat-v3.1",
			name: "DeepSeek: DeepSeek V3.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.95,
				cacheRead: 0.13,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-r1": {
			id: "deepseek/deepseek-r1",
			name: "DeepSeek: R1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 64000,
			maxTokens: 16000,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-r1-0528": {
			id: "deepseek/deepseek-r1-0528",
			name: "DeepSeek: R1 0528",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.5,
				output: 2.1500000000000004,
				cacheRead: 0.35,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v3.1-terminus": {
			id: "deepseek/deepseek-v3.1-terminus",
			name: "DeepSeek: DeepSeek V3.1 Terminus",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.27,
				output: 1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 147456,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v3.2": {
			id: "deepseek/deepseek-v3.2",
			name: "DeepSeek: DeepSeek V3.2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25899999999999995,
				output: 0.42,
				cacheRead: 0.135,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 147456,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v3.2-exp": {
			id: "deepseek/deepseek-v3.2-exp",
			name: "DeepSeek: DeepSeek V3.2 Exp",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.27,
				output: 0.41,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 147456,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4-flash": {
			id: "deepseek/deepseek-v4-flash",
			name: "DeepSeek: DeepSeek V4 Flash 0423",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.005699999999999999,
				output: 1.28,
				cacheRead: 0.005699999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4-flash-0731": {
			id: "deepseek/deepseek-v4-flash-0731",
			name: "DeepSeek: DeepSeek V4 Flash 0731",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.0053,
				output: 1.28,
				cacheRead: 0.0053,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4-flash-vision-exp": {
			id: "deepseek/deepseek-v4-flash-vision-exp",
			name: "DeepSeek: DeepSeek V4 Flash Vision Exp",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.21559999999999999,
				output: 0.6468,
				cacheRead: 0.00686,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4-pro": {
			id: "deepseek/deepseek-v4-pro",
			name: "DeepSeek: DeepSeek V4 Pro 0423",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.222894,
				output: 0.445788,
				cacheRead: 0.018574499999999997,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 384000,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4-pro-0813": {
			id: "deepseek/deepseek-v4-pro-0813",
			name: "DeepSeek: DeepSeek V4 Pro 0813",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.66,
				output: 1.9800000000000002,
				cacheRead: 0.022,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 393216,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4.1-flash": {
			id: "deepseek/deepseek-v4.1-flash",
			name: "DeepSeek: DeepSeek V4.1 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.006,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"deepseek/deepseek-v4.1-flash:batch": {
			id: "deepseek/deepseek-v4.1-flash:batch",
			name: "DeepSeek: DeepSeek V4.1 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.112,
				output: 0.33599999999999997,
				cacheRead: 0.00336,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"dots-studio/dots-3-note-preview:free": {
			id: "dots-studio/dots-3-note-preview:free",
			name: "Dots Studio: Dots3-Note Preview (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 512000,
			maxTokens: 460800,
		} satisfies Model<"openai-completions">,
		"fireworks/ember-1": {
			id: "fireworks/ember-1",
			name: "Fireworks: Ember-1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-flash": {
			id: "google/gemini-2.5-flash",
			name: "Google: Gemini 2.5 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-flash-lite": {
			id: "google/gemini-2.5-flash-lite",
			name: "Google: Gemini 2.5 Flash Lite",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.39999999999999997,
				cacheRead: 0.01,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-flash-lite:batch": {
			id: "google/gemini-2.5-flash-lite:batch",
			name: "Google: Gemini 2.5 Flash Lite (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.19999999999999998,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-flash:batch": {
			id: "google/gemini-2.5-flash:batch",
			name: "Google: Gemini 2.5 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 1.25,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-pro": {
			id: "google/gemini-2.5-pro",
			name: "Google: Gemini 2.5 Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0.375,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-pro-preview": {
			id: "google/gemini-2.5-pro-preview",
			name: "Google: Gemini 2.5 Pro Preview 06-05",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0.375,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-2.5-pro:batch": {
			id: "google/gemini-2.5-pro:batch",
			name: "Google: Gemini 2.5 Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.625,
				output: 5,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3-flash-preview": {
			id: "google/gemini-3-flash-preview",
			name: "Google: Gemini 3 Flash Preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3-flash-preview:batch": {
			id: "google/gemini-3-flash-preview:batch",
			name: "Google: Gemini 3 Flash Preview (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3-pro-image": {
			id: "google/gemini-3-pro-image",
			name: "Google: Nano Banana Pro (Gemini 3 Pro Image)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0.375,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.1-flash-lite": {
			id: "google/gemini-3.1-flash-lite",
			name: "Google: Gemini 3.1 Flash Lite",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.5,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.1-flash-lite-preview": {
			id: "google/gemini-3.1-flash-lite-preview",
			name: "Google: Gemini 3.1 Flash Lite Preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.5,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.1-flash-lite:batch": {
			id: "google/gemini-3.1-flash-lite:batch",
			name: "Google: Gemini 3.1 Flash Lite (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.125,
				output: 0.75,
				cacheRead: 0.012499999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.1-pro-preview": {
			id: "google/gemini-3.1-pro-preview",
			name: "Google: Gemini 3.1 Pro Preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0.375,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.1-pro-preview-customtools": {
			id: "google/gemini-3.1-pro-preview-customtools",
			name: "Google: Gemini 3.1 Pro Preview Custom Tools",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0.375,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.1-pro-preview:batch": {
			id: "google/gemini-3.1-pro-preview:batch",
			name: "Google: Gemini 3.1 Pro Preview (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.5-flash": {
			id: "google/gemini-3.5-flash",
			name: "Google: Gemini 3.5 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 9,
				cacheRead: 0.15,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.5-flash-lite": {
			id: "google/gemini-3.5-flash-lite",
			name: "Google: Gemini 3.5 Flash Lite",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0.0833333333333333,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.5-flash-lite:batch": {
			id: "google/gemini-3.5-flash-lite:batch",
			name: "Google: Gemini 3.5 Flash Lite (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 1.25,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.5-flash:batch": {
			id: "google/gemini-3.5-flash:batch",
			name: "Google: Gemini 3.5 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.6-flash": {
			id: "google/gemini-3.6-flash",
			name: "Google: Gemini 3.6 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.6-flash:batch": {
			id: "google/gemini-3.6-flash:batch",
			name: "Google: Gemini 3.6 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.375,
				output: 1.875,
				cacheRead: 0.0375,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.7-flash": {
			id: "google/gemini-3.7-flash",
			name: "Google: Gemini 3.7 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.7-flash:batch": {
			id: "google/gemini-3.7-flash:batch",
			name: "Google: Gemini 3.7 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.375,
				output: 1.875,
				cacheRead: 0.0375,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.8-flash": {
			id: "google/gemini-3.8-flash",
			name: "Google: Gemini 3.8 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-3.8-flash:batch": {
			id: "google/gemini-3.8-flash:batch",
			name: "Google: Gemini 3.8 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.375,
				output: 1.875,
				cacheRead: 0.0375,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"google/gemini-nano-banana-2.1": {
			id: "google/gemini-nano-banana-2.1",
			name: "Google: Nano Banana 2.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 65536,
			maxTokens: 58982,
		} satisfies Model<"openai-completions">,
		"google/gemma-3-12b-it": {
			id: "google/gemma-3-12b-it",
			name: "Google: Gemma 3 12B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"google/gemma-3-27b-it": {
			id: "google/gemma-3-27b-it",
			name: "Google: Gemma 3 27B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.08,
				output: 0.44999999999999996,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"google/gemma-4-26b-a4b-it": {
			id: "google/gemma-4-26b-a4b-it",
			name: "Google: Gemma 4 26B A4B ",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09,
				output: 0.3,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"google/gemma-4-26b-a4b-it:free": {
			id: "google/gemma-4-26b-a4b-it:free",
			name: "Google: Gemma 4 26B A4B  (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"google/gemma-4-31b-it": {
			id: "google/gemma-4-31b-it",
			name: "Google: Gemma 4 31B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09,
				output: 0.33999999999999997,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"google/gemma-4-31b-it:free": {
			id: "google/gemma-4-31b-it:free",
			name: "Google: Gemma 4 31B (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"ibm-granite/granite-4.2-8b": {
			id: "ibm-granite/granite-4.2-8b",
			name: "IBM: Granite 4.2 8B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.25,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"inception/mercury-2": {
			id: "inception/mercury-2",
			name: "Inception: Mercury 2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.75,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 50000,
		} satisfies Model<"openai-completions">,
		"inception/mercury-2.5": {
			id: "inception/mercury-2.5",
			name: "Inception: Mercury 2.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.04,
				output: 0.15,
				cacheRead: 0.004,
				cacheWrite: 0,
			},
			contextWindow: 260000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"inclusionai/ling-3.0-flash": {
			id: "inclusionai/ling-3.0-flash",
			name: "inclusionAI: Ling 3.0 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.020999999999999998,
				output: 0.063,
				cacheRead: 0.004200000000000001,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"inclusionai/ling-3.0-flash-fin": {
			id: "inclusionai/ling-3.0-flash-fin",
			name: "inclusionAI: Ling 3.0 Flash Fin",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.041999999999999996,
				output: 0.12319999999999999,
				cacheRead: 0.008400000000000001,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"inclusionai/ling-3.0-flash-sante": {
			id: "inclusionai/ling-3.0-flash-sante",
			name: "inclusionAI: Ling 3.0 Flash Sante",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.041999999999999996,
				output: 0.12319999999999999,
				cacheRead: 0.008400000000000001,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"inclusionai/ling-3.0-flash-vl": {
			id: "inclusionai/ling-3.0-flash-vl",
			name: "inclusionAI: Ling 3.0 Flash VL",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.020999999999999998,
				output: 0.061599999999999995,
				cacheRead: 0.004200000000000001,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"inclusionai/ling-3.1-flash": {
			id: "inclusionai/ling-3.1-flash",
			name: "inclusionAI: Ling 3.1 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"liquid/lfm-2.5-2.6b:free": {
			id: "liquid/lfm-2.5-2.6b:free",
			name: "LiquidAI: LFM2.5-2.6B (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 65536,
			maxTokens: 8192,
		} satisfies Model<"openai-completions">,
		"meituan/longcat-2.0": {
			id: "meituan/longcat-2.0",
			name: "Meituan: LongCat 2.0",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.006,
				cacheWrite: 0,
			},
			contextWindow: 1048756,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"meta-llama/llama-3.1-70b-instruct": {
			id: "meta-llama/llama-3.1-70b-instruct",
			name: "Meta: Llama 3.1 70B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.39999999999999997,
				output: 0.39999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"meta-llama/llama-3.1-8b-instruct": {
			id: "meta-llama/llama-3.1-8b-instruct",
			name: "Meta: Llama 3.1 8B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.049999999999999996,
				output: 0.08,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"meta-llama/llama-3.3-70b-instruct": {
			id: "meta-llama/llama-3.3-70b-instruct",
			name: "Meta: Llama 3.3 70B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.22,
				output: 0.5,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"meta-llama/llama-4-maverick": {
			id: "meta-llama/llama-4-maverick",
			name: "Meta: Llama 4 Maverick",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.1875,
				output: 0.6525,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"meta-llama/llama-4-scout": {
			id: "meta-llama/llama-4-scout",
			name: "Meta: Llama 4 Scout",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1310720,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"meta/muse-glimmer-30b": {
			id: "meta/muse-glimmer-30b",
			name: "Meta: Muse Glimmer 30B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"meta/muse-spark-1.1": {
			id: "meta/muse-spark-1.1",
			name: "Meta: Muse Spark 1.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"meta/muse-spark-1.2": {
			id: "meta/muse-spark-1.2",
			name: "Meta: Muse Spark 1.2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"meta/muse-spark-1.2-contributor": {
			id: "meta/muse-spark-1.2-contributor",
			name: "Meta: Muse Spark 1.2 Contributor",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.19999999999999998,
				cacheRead: 0.002,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"meta/muse-spark-1.3": {
			id: "meta/muse-spark-1.3",
			name: "Meta: Muse Spark 1.3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"meta/muse-spark-1.3-contributor": {
			id: "meta/muse-spark-1.3-contributor",
			name: "Meta: Muse Spark 1.3 Contributor",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.19999999999999998,
				cacheRead: 0.002,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"minimax/minimax-m1": {
			id: "minimax/minimax-m1",
			name: "MiniMax: MiniMax M1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.55,
				output: 2.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 40000,
		} satisfies Model<"openai-completions">,
		"minimax/minimax-m2": {
			id: "minimax/minimax-m2",
			name: "MiniMax: MiniMax M2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 176947,
		} satisfies Model<"openai-completions">,
		"minimax/minimax-m2.1": {
			id: "minimax/minimax-m2.1",
			name: "MiniMax: MiniMax M2.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"minimax/minimax-m2.5": {
			id: "minimax/minimax-m2.5",
			name: "MiniMax: MiniMax M2.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.27,
				output: 1.08,
				cacheRead: 0.027,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"minimax/minimax-m2.7": {
			id: "minimax/minimax-m2.7",
			name: "MiniMax: MiniMax M2.7",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.21,
				output: 0.84,
				cacheRead: 0.041999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 176947,
		} satisfies Model<"openai-completions">,
		"minimax/minimax-m3": {
			id: "minimax/minimax-m3",
			name: "MiniMax: MiniMax M3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 512000,
		} satisfies Model<"openai-completions">,
		"mistralai/codestral-2508": {
			id: "mistralai/codestral-2508",
			name: "Mistral: Codestral 2508",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 0.8999999999999999,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 204800,
		} satisfies Model<"openai-completions">,
		"mistralai/codestral-2508:batch": {
			id: "mistralai/codestral-2508:batch",
			name: "Mistral: Codestral 2508 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.44999999999999996,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 204800,
		} satisfies Model<"openai-completions">,
		"mistralai/devstral-2512": {
			id: "mistralai/devstral-2512",
			name: "Mistral: Devstral 2 2512",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.39999999999999997,
				output: 2,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/ministral-14b-2512": {
			id: "mistralai/ministral-14b-2512",
			name: "Mistral: Ministral 3 14B 2512",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.19999999999999998,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/ministral-3b-2512": {
			id: "mistralai/ministral-3b-2512",
			name: "Mistral: Ministral 3 3B 2512",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.09999999999999999,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 104857,
		} satisfies Model<"openai-completions">,
		"mistralai/ministral-8b-2512": {
			id: "mistralai/ministral-8b-2512",
			name: "Mistral: Ministral 3 8B 2512",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/ministral-8b-2512:batch": {
			id: "mistralai/ministral-8b-2512:batch",
			name: "Mistral: Ministral 3 8B 2512 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.075,
				cacheRead: 0.0075,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-large": {
			id: "mistralai/mistral-large",
			name: "Mistral Large",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 102400,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-large-2407": {
			id: "mistralai/mistral-large-2407",
			name: "Mistral Large 2407",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 104857,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-large-2512": {
			id: "mistralai/mistral-large-2512",
			name: "Mistral: Mistral Large 3 2512",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-large-2512:batch": {
			id: "mistralai/mistral-large-2512:batch",
			name: "Mistral: Mistral Large 3 2512 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 0.75,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-large-4-0": {
			id: "mistralai/mistral-large-4-0",
			name: "Mistral: Mistral Large 4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6799999999999999,
				output: 2.09,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-medium-3": {
			id: "mistralai/mistral-medium-3",
			name: "Mistral: Mistral Medium 3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 2,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 104857,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-medium-3-5": {
			id: "mistralai/mistral-medium-3-5",
			name: "Mistral: Mistral Medium 3.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-medium-3-5:batch": {
			id: "mistralai/mistral-medium-3-5:batch",
			name: "Mistral: Mistral Medium 3.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-medium-3.1": {
			id: "mistralai/mistral-medium-3.1",
			name: "Mistral: Mistral Medium 3.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 2,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 104857,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-medium-3.1:batch": {
			id: "mistralai/mistral-medium-3.1:batch",
			name: "Mistral: Mistral Medium 3.1 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 104857,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-nemo": {
			id: "mistralai/mistral-nemo",
			name: "Mistral: Mistral Nemo",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.029,
				output: 0.03,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-saba": {
			id: "mistralai/mistral-saba",
			name: "Mistral: Saba",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.19999999999999998,
				output: 0.6,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 26214,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-small-2603": {
			id: "mistralai/mistral-small-2603",
			name: "Mistral: Mistral Small 4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-small-2603:batch": {
			id: "mistralai/mistral-small-2603:batch",
			name: "Mistral: Mistral Small 4 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0.0075,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 209715,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-small-3.1-24b-instruct": {
			id: "mistralai/mistral-small-3.1-24b-instruct",
			name: "Mistral: Mistral Small 3.1 24B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.351,
				output: 0.5549999999999999,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 102400,
		} satisfies Model<"openai-completions">,
		"mistralai/mistral-small-3.2-24b-instruct": {
			id: "mistralai/mistral-small-3.2-24b-instruct",
			name: "Mistral: Mistral Small 3.2 24B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09375,
				output: 0.25,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"mistralai/mixtral-8x22b-instruct": {
			id: "mistralai/mixtral-8x22b-instruct",
			name: "Mistral: Mixtral 8x22B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 65536,
			maxTokens: 52428,
		} satisfies Model<"openai-completions">,
		"mistralai/voxtral-small-24b-2507": {
			id: "mistralai/voxtral-small-24b-2507",
			name: "Mistral: Voxtral Small 24B 2507",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.09999999999999999,
				output: 0.3,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 26214,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k2": {
			id: "moonshotai/kimi-k2",
			name: "MoonshotAI: Kimi K2 0711",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.5700000000000001,
				output: 2.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 98304,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k2-0905": {
			id: "moonshotai/kimi-k2-0905",
			name: "MoonshotAI: Kimi K2 0905",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 98304,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k2-thinking": {
			id: "moonshotai/kimi-k2-thinking",
			name: "MoonshotAI: Kimi K2 Thinking",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k2.5": {
			id: "moonshotai/kimi-k2.5",
			name: "MoonshotAI: Kimi K2.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.41,
				output: 2.06,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k2.6": {
			id: "moonshotai/kimi-k2.6",
			name: "MoonshotAI: Kimi K2.6",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.4344,
				output: 2.4499999999999997,
				cacheRead: 0.1077,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k2.7-code": {
			id: "moonshotai/kimi-k2.7-code",
			name: "MoonshotAI: Kimi K2.7 Code",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6712,
				output: 3.35,
				cacheRead: 0.18,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k3": {
			id: "moonshotai/kimi-k3",
			name: "MoonshotAI: Kimi K3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.8999999999999999,
				output: 14,
				cacheRead: 0.6,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"moonshotai/kimi-k3:batch": {
			id: "moonshotai/kimi-k3:batch",
			name: "MoonshotAI: Kimi K3 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.2800000000000002,
				output: 11.399999999999999,
				cacheRead: 0.228,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"nex-agi/nex-n2.5-pro": {
			id: "nex-agi/nex-n2.5-pro",
			name: "Nex AGI: Nex-N2.5-Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.25,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3-nano-30b-a3b": {
			id: "nvidia/nemotron-3-nano-30b-a3b",
			name: "NVIDIA: Nemotron 3 Nano 30B A3B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.24,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free": {
			id: "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free",
			name: "NVIDIA: Nemotron 3 Nano Omni (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3-super-120b-a12b": {
			id: "nvidia/nemotron-3-super-120b-a12b",
			name: "NVIDIA: Nemotron 3 Super",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.08,
				output: 0.44999999999999996,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3-super-120b-a12b:free": {
			id: "nvidia/nemotron-3-super-120b-a12b:free",
			name: "NVIDIA: Nemotron 3 Super (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3-ultra-550b-a55b": {
			id: "nvidia/nemotron-3-ultra-550b-a55b",
			name: "NVIDIA: Nemotron 3 Ultra",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.5,
				output: 2.2,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3-ultra-550b-a55b:free": {
			id: "nvidia/nemotron-3-ultra-550b-a55b:free",
			name: "NVIDIA: Nemotron 3 Ultra (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3.5-lightning": {
			id: "nvidia/nemotron-3.5-lightning",
			name: "NVIDIA: Nemotron 3.5 Lightning",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.046900000000000004,
				output: 0.134,
				cacheRead: 0.023450000000000002,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"nvidia/nemotron-3.5-lightning:free": {
			id: "nvidia/nemotron-3.5-lightning:free",
			name: "NVIDIA: Nemotron 3.5 Lightning (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"openai/gpt-3.5-turbo": {
			id: "openai/gpt-3.5-turbo",
			name: "OpenAI: GPT-3.5 Turbo",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 16385,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-3.5-turbo-0613": {
			id: "openai/gpt-3.5-turbo-0613",
			name: "OpenAI: GPT-3.5 Turbo (older v0613)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1,
				output: 2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 4095,
			maxTokens: 3685,
		} satisfies Model<"openai-completions">,
		"openai/gpt-3.5-turbo-16k": {
			id: "openai/gpt-3.5-turbo-16k",
			name: "OpenAI: GPT-3.5 Turbo 16k",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 3,
				output: 4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 16385,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-3.5-turbo:batch": {
			id: "openai/gpt-3.5-turbo:batch",
			name: "OpenAI: GPT-3.5 Turbo (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.75,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 16385,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4": {
			id: "openai/gpt-4",
			name: "OpenAI: GPT-4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 30,
				output: 60,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 8191,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4-turbo": {
			id: "openai/gpt-4-turbo",
			name: "OpenAI: GPT-4 Turbo",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 30,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4-turbo:batch": {
			id: "openai/gpt-4-turbo:batch",
			name: "OpenAI: GPT-4 Turbo (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4.1": {
			id: "openai/gpt-4.1",
			name: "OpenAI: GPT-4.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4.1-mini": {
			id: "openai/gpt-4.1-mini",
			name: "OpenAI: GPT-4.1 Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 1.5999999999999999,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4.1-mini:batch": {
			id: "openai/gpt-4.1-mini:batch",
			name: "OpenAI: GPT-4.1 Mini (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.7999999999999999,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4.1-nano": {
			id: "openai/gpt-4.1-nano",
			name: "OpenAI: GPT-4.1 Nano",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.39999999999999997,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4.1-nano:batch": {
			id: "openai/gpt-4.1-nano:batch",
			name: "OpenAI: GPT-4.1 Nano (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.19999999999999998,
				cacheRead: 0.012499999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4.1:batch": {
			id: "openai/gpt-4.1:batch",
			name: "OpenAI: GPT-4.1 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 4,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o": {
			id: "openai/gpt-4o",
			name: "OpenAI: GPT-4o",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o-2024-05-13": {
			id: "openai/gpt-4o-2024-05-13",
			name: "OpenAI: GPT-4o (2024-05-13)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o-2024-08-06": {
			id: "openai/gpt-4o-2024-08-06",
			name: "OpenAI: GPT-4o (2024-08-06)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o-2024-11-20": {
			id: "openai/gpt-4o-2024-11-20",
			name: "OpenAI: GPT-4o (2024-11-20)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o-mini": {
			id: "openai/gpt-4o-mini",
			name: "OpenAI: GPT-4o-mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o-mini-2024-07-18": {
			id: "openai/gpt-4o-mini-2024-07-18",
			name: "OpenAI: GPT-4o-mini (2024-07-18)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o-mini:batch": {
			id: "openai/gpt-4o-mini:batch",
			name: "OpenAI: GPT-4o-mini (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0.0375,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-4o:batch": {
			id: "openai/gpt-4o:batch",
			name: "OpenAI: GPT-4o (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 5,
				cacheRead: 0.625,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5": {
			id: "openai/gpt-5",
			name: "OpenAI: GPT-5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5-mini": {
			id: "openai/gpt-5-mini",
			name: "OpenAI: GPT-5 Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5-mini:batch": {
			id: "openai/gpt-5-mini:batch",
			name: "OpenAI: GPT-5 Mini (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.125,
				output: 1,
				cacheRead: 0.012499999999999999,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5-nano": {
			id: "openai/gpt-5-nano",
			name: "OpenAI: GPT-5 Nano",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.39999999999999997,
				cacheRead: 0.005,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5-nano:batch": {
			id: "openai/gpt-5-nano:batch",
			name: "OpenAI: GPT-5 Nano (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.024999999999999998,
				output: 0.19999999999999998,
				cacheRead: 0.0025,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5-pro": {
			id: "openai/gpt-5-pro",
			name: "OpenAI: GPT-5 Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 120,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5-pro:batch": {
			id: "openai/gpt-5-pro:batch",
			name: "OpenAI: GPT-5 Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 7.5,
				output: 60,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.1": {
			id: "openai/gpt-5.1",
			name: "OpenAI: GPT-5.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.1-codex": {
			id: "openai/gpt-5.1-codex",
			name: "OpenAI: GPT-5.1-Codex",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.13,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.1-codex-max": {
			id: "openai/gpt-5.1-codex-max",
			name: "OpenAI: GPT-5.1-Codex-Max",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.1-codex-mini": {
			id: "openai/gpt-5.1-codex-mini",
			name: "OpenAI: GPT-5.1-Codex-Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.1:batch": {
			id: "openai/gpt-5.1:batch",
			name: "OpenAI: GPT-5.1 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.625,
				output: 5,
				cacheRead: 0.0625,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.2": {
			id: "openai/gpt-5.2",
			name: "OpenAI: GPT-5.2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.2-chat": {
			id: "openai/gpt-5.2-chat",
			name: "OpenAI: GPT-5.2 Chat",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 32000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.2-codex": {
			id: "openai/gpt-5.2-codex",
			name: "OpenAI: GPT-5.2-Codex",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.2-pro": {
			id: "openai/gpt-5.2-pro",
			name: "OpenAI: GPT-5.2 Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 21,
				output: 168,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.2-pro:batch": {
			id: "openai/gpt-5.2-pro:batch",
			name: "OpenAI: GPT-5.2 Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10.5,
				output: 84,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.2:batch": {
			id: "openai/gpt-5.2:batch",
			name: "OpenAI: GPT-5.2 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.875,
				output: 7,
				cacheRead: 0.0875,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.3-codex": {
			id: "openai/gpt-5.3-codex",
			name: "OpenAI: GPT-5.3-Codex",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4": {
			id: "openai/gpt-5.4",
			name: "OpenAI: GPT-5.4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4-mini": {
			id: "openai/gpt-5.4-mini",
			name: "OpenAI: GPT-5.4 Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4-mini:batch": {
			id: "openai/gpt-5.4-mini:batch",
			name: "OpenAI: GPT-5.4 Mini (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.375,
				output: 2.25,
				cacheRead: 0.0375,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4-nano": {
			id: "openai/gpt-5.4-nano",
			name: "OpenAI: GPT-5.4 Nano",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.25,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4-nano:batch": {
			id: "openai/gpt-5.4-nano:batch",
			name: "OpenAI: GPT-5.4 Nano (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.625,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4-pro": {
			id: "openai/gpt-5.4-pro",
			name: "OpenAI: GPT-5.4 Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4-pro:batch": {
			id: "openai/gpt-5.4-pro:batch",
			name: "OpenAI: GPT-5.4 Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 90,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.4:batch": {
			id: "openai/gpt-5.4:batch",
			name: "OpenAI: GPT-5.4 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 7.5,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.5": {
			id: "openai/gpt-5.5",
			name: "OpenAI: GPT-5.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.5-pro": {
			id: "openai/gpt-5.5-pro",
			name: "OpenAI: GPT-5.5 Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.5-pro:batch": {
			id: "openai/gpt-5.5-pro:batch",
			name: "OpenAI: GPT-5.5 Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 90,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.5:batch": {
			id: "openai/gpt-5.5:batch",
			name: "OpenAI: GPT-5.5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-luna": {
			id: "openai/gpt-5.6-luna",
			name: "OpenAI: GPT-5.6 Luna",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-luna-pro": {
			id: "openai/gpt-5.6-luna-pro",
			name: "OpenAI: GPT-5.6 Luna Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-luna-pro:batch": {
			id: "openai/gpt-5.6-luna-pro:batch",
			name: "OpenAI: GPT-5.6 Luna Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.6,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-luna:batch": {
			id: "openai/gpt-5.6-luna:batch",
			name: "OpenAI: GPT-5.6 Luna (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.6,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-sol": {
			id: "openai/gpt-5.6-sol",
			name: "OpenAI: GPT-5.6 Sol",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-sol-pro": {
			id: "openai/gpt-5.6-sol-pro",
			name: "OpenAI: GPT-5.6 Sol Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-sol-pro:batch": {
			id: "openai/gpt-5.6-sol-pro:batch",
			name: "OpenAI: GPT-5.6 Sol Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-sol:batch": {
			id: "openai/gpt-5.6-sol:batch",
			name: "OpenAI: GPT-5.6 Sol (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-terra": {
			id: "openai/gpt-5.6-terra",
			name: "OpenAI: GPT-5.6 Terra",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-terra-pro": {
			id: "openai/gpt-5.6-terra-pro",
			name: "OpenAI: GPT-5.6 Terra Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-terra-pro:batch": {
			id: "openai/gpt-5.6-terra-pro:batch",
			name: "OpenAI: GPT-5.6 Terra Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 6,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5.6-terra:batch": {
			id: "openai/gpt-5.6-terra:batch",
			name: "OpenAI: GPT-5.6 Terra (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 6,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-5:batch": {
			id: "openai/gpt-5:batch",
			name: "OpenAI: GPT-5 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.625,
				output: 5,
				cacheRead: 0.0625,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-astra": {
			id: "openai/gpt-6-astra",
			name: "OpenAI: GPT-6 Astra",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-astra-pro": {
			id: "openai/gpt-6-astra-pro",
			name: "OpenAI: GPT-6 Astra Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-astra-pro:batch": {
			id: "openai/gpt-6-astra-pro:batch",
			name: "OpenAI: GPT-6 Astra Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-astra:batch": {
			id: "openai/gpt-6-astra:batch",
			name: "OpenAI: GPT-6 Astra (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-luna": {
			id: "openai/gpt-6-luna",
			name: "OpenAI: GPT-6 Luna",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-luna-pro": {
			id: "openai/gpt-6-luna-pro",
			name: "OpenAI: GPT-6 Luna Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-luna-pro:batch": {
			id: "openai/gpt-6-luna-pro:batch",
			name: "OpenAI: GPT-6 Luna Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.25,
				cacheRead: 0.005,
				cacheWrite: 0.0625,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-luna:batch": {
			id: "openai/gpt-6-luna:batch",
			name: "OpenAI: GPT-6 Luna (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.25,
				cacheRead: 0.005,
				cacheWrite: 0.0625,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-sol": {
			id: "openai/gpt-6-sol",
			name: "OpenAI: GPT-6 Sol",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-sol-pro": {
			id: "openai/gpt-6-sol-pro",
			name: "OpenAI: GPT-6 Sol Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-sol-pro:batch": {
			id: "openai/gpt-6-sol-pro:batch",
			name: "OpenAI: GPT-6 Sol Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6-sol:batch": {
			id: "openai/gpt-6-sol:batch",
			name: "OpenAI: GPT-6 Sol (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6.1-sol": {
			id: "openai/gpt-6.1-sol",
			name: "OpenAI: GPT-6.1 Sol",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6.1-sol-pro": {
			id: "openai/gpt-6.1-sol-pro",
			name: "OpenAI: GPT-6.1 Sol Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6.1-sol-pro:batch": {
			id: "openai/gpt-6.1-sol-pro:batch",
			name: "OpenAI: GPT-6.1 Sol Pro (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 1.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-6.1-sol:batch": {
			id: "openai/gpt-6.1-sol:batch",
			name: "OpenAI: GPT-6.1 Sol (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 1.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-audio": {
			id: "openai/gpt-audio",
			name: "OpenAI: GPT Audio",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-audio-mini": {
			id: "openai/gpt-audio-mini",
			name: "OpenAI: GPT Audio Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"openai/gpt-chat-latest": {
			id: "openai/gpt-chat-latest",
			name: "OpenAI: GPT Chat Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-120b": {
			id: "openai/gpt-oss-120b",
			name: "OpenAI: gpt-oss-120b",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.037,
				output: 0.16999999999999998,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-120b:batch": {
			id: "openai/gpt-oss-120b:batch",
			name: "OpenAI: gpt-oss-120b (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.0296,
				output: 0.136,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-20b": {
			id: "openai/gpt-oss-20b",
			name: "OpenAI: gpt-oss-20b",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.018,
				output: 0.09,
				cacheRead: 0.009,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-20b:batch": {
			id: "openai/gpt-oss-20b:batch",
			name: "OpenAI: gpt-oss-20b (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.024,
				output: 0.112,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"openai/gpt-oss-safeguard-20b": {
			id: "openai/gpt-oss-safeguard-20b",
			name: "OpenAI: gpt-oss-safeguard-20b",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.075,
				output: 0.3,
				cacheRead: 0.0375,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"openai/o1": {
			id: "openai/o1",
			name: "OpenAI: o1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 60,
				cacheRead: 7.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o3": {
			id: "openai/o3",
			name: "OpenAI: o3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o3-mini": {
			id: "openai/o3-mini",
			name: "OpenAI: o3 Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o3-mini-high": {
			id: "openai/o3-mini-high",
			name: "OpenAI: o3 Mini High",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o3-mini:batch": {
			id: "openai/o3-mini:batch",
			name: "OpenAI: o3 Mini (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.55,
				output: 2.2,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o3-pro": {
			id: "openai/o3-pro",
			name: "OpenAI: o3 Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 20,
				output: 80,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o3:batch": {
			id: "openai/o3:batch",
			name: "OpenAI: o3 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 4,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o4-mini": {
			id: "openai/o4-mini",
			name: "OpenAI: o4 Mini",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o4-mini-high": {
			id: "openai/o4-mini-high",
			name: "OpenAI: o4 Mini High",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openai/o4-mini:batch": {
			id: "openai/o4-mini:batch",
			name: "OpenAI: o4 Mini (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.55,
				output: 2.2,
				cacheRead: 0.1375,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"openai-completions">,
		"openrouter/auto": {
			id: "openrouter/auto",
			name: "Auto Router",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: -1000000,
				output: -1000000,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openrouter/auto-beta": {
			id: "openrouter/auto-beta",
			name: "Auto Router (Beta)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: -1000000,
				output: -1000000,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"openrouter/free": {
			id: "openrouter/free",
			name: "Free Models Router",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"perceptron/perceptron-mk1.5": {
			id: "perceptron/perceptron-mk1.5",
			name: "Perceptron: Perceptron Mk1.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 36864,
			maxTokens: 8192,
		} satisfies Model<"openai-completions">,
		"poolside/laguna-s-2.1": {
			id: "poolside/laguna-s-2.1",
			name: "Poolside: Laguna S 2.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.09,
				output: 0.18,
				cacheRead: 0.009,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"poolside/laguna-s-2.1:free": {
			id: "poolside/laguna-s-2.1:free",
			name: "Poolside: Laguna S 2.1 (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"poolside/laguna-xs-2.1": {
			id: "poolside/laguna-xs-2.1",
			name: "Poolside: Laguna XS 2.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.12,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"poolside/laguna-xs-2.1:free": {
			id: "poolside/laguna-xs-2.1:free",
			name: "Poolside: Laguna XS 2.1 (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"prism-ml/ternary-bonsai-2-27b": {
			id: "prism-ml/ternary-bonsai-2-27b",
			name: "PrismML: Ternary Bonsai 2 27B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.5,
				cacheRead: 0.0375,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"qwen/qwen-2.5-72b-instruct": {
			id: "qwen/qwen-2.5-72b-instruct",
			name: "Qwen2.5 72B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.36,
				output: 0.39999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen-2.5-7b-instruct": {
			id: "qwen/qwen-2.5-7b-instruct",
			name: "Qwen: Qwen2.5 7B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.09999999999999999,
				output: 0.19999999999999998,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 29491,
		} satisfies Model<"openai-completions">,
		"qwen/qwen-plus": {
			id: "qwen/qwen-plus",
			name: "Qwen: Qwen-Plus",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.26,
				output: 0.78,
				cacheRead: 0.052000000000000005,
				cacheWrite: 0.325,
			},
			contextWindow: 1000000,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-14b": {
			id: "qwen/qwen3-14b",
			name: "Qwen: Qwen3 14B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.12,
				output: 0.24,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 40960,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-235b-a22b-2507": {
			id: "qwen/qwen3-235b-a22b-2507",
			name: "Qwen: Qwen3 235B A22B Instruct 2507",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.09,
				output: 0.55,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-235b-a22b-thinking-2507": {
			id: "qwen/qwen3-235b-a22b-thinking-2507",
			name: "Qwen: Qwen3 235B A22B Thinking 2507",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.44999999999999996,
				output: 3.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-30b-a3b": {
			id: "qwen/qwen3-30b-a3b",
			name: "Qwen: Qwen3 30B A3B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.12,
				output: 0.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 40960,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-30b-a3b-instruct-2507": {
			id: "qwen/qwen3-30b-a3b-instruct-2507",
			name: "Qwen: Qwen3 30B A3B Instruct 2507",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.09999999999999999,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-32b": {
			id: "qwen/qwen3-32b",
			name: "Qwen: Qwen3 32B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.08,
				output: 0.28,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-coder": {
			id: "qwen/qwen3-coder",
			name: "Qwen: Qwen3 Coder 480B A35B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-coder-30b-a3b-instruct": {
			id: "qwen/qwen3-coder-30b-a3b-instruct",
			name: "Qwen: Qwen3 Coder 30B A3B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.28,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-coder-flash": {
			id: "qwen/qwen3-coder-flash",
			name: "Qwen: Qwen3 Coder Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.195,
				output: 0.975,
				cacheRead: 0.039,
				cacheWrite: 0.24375,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-coder-next": {
			id: "qwen/qwen3-coder-next",
			name: "Qwen: Qwen3 Coder Next",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.12,
				output: 0.7999999999999999,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-next-80b-a3b-instruct": {
			id: "qwen/qwen3-next-80b-a3b-instruct",
			name: "Qwen: Qwen3 Next 80B A3B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.09999999999999999,
				output: 1.1,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-next-80b-a3b-thinking": {
			id: "qwen/qwen3-next-80b-a3b-thinking",
			name: "Qwen: Qwen3 Next 80B A3B Thinking",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-vl-235b-a22b-instruct": {
			id: "qwen/qwen3-vl-235b-a22b-instruct",
			name: "Qwen: Qwen3 VL 235B A22B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.21,
				output: 1.9,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-vl-30b-a3b-instruct": {
			id: "qwen/qwen3-vl-30b-a3b-instruct",
			name: "Qwen: Qwen3 VL 30B A3B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-vl-30b-a3b-thinking": {
			id: "qwen/qwen3-vl-30b-a3b-thinking",
			name: "Qwen: Qwen3 VL 30B A3B Thinking",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.29,
				output: 1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3-vl-8b-instruct": {
			id: "qwen/qwen3-vl-8b-instruct",
			name: "Qwen: Qwen3 VL 8B Instruct",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 0.75,
				cacheRead: 0.12,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-122b-a10b": {
			id: "qwen/qwen3.5-122b-a10b",
			name: "Qwen: Qwen3.5-122B-A10B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.26,
				output: 2.08,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-27b": {
			id: "qwen/qwen3.5-27b",
			name: "Qwen: Qwen3.5-27B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.26,
				output: 2.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 81920,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-35b-a3b": {
			id: "qwen/qwen3.5-35b-a3b",
			name: "Qwen: Qwen3.5-35B-A3B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.08,
				output: 0.75,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-397b-a17b": {
			id: "qwen/qwen3.5-397b-a17b",
			name: "Qwen: Qwen3.5 397B A17B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.55,
				output: 3.5,
				cacheRead: 0.22499999999999998,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-9b": {
			id: "qwen/qwen3.5-9b",
			name: "Qwen: Qwen3.5-9B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.15,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-flash-02-23": {
			id: "qwen/qwen3.5-flash-02-23",
			name: "Qwen: Qwen3.5-Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.065,
				output: 0.26,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-plus-02-15": {
			id: "qwen/qwen3.5-plus-02-15",
			name: "Qwen: Qwen3.5 Plus 2026-02-15",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.26,
				output: 1.56,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.5-plus-20260420": {
			id: "qwen/qwen3.5-plus-20260420",
			name: "Qwen: Qwen3.5 Plus 2026-04-20",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.7999999999999998,
				cacheRead: 0,
				cacheWrite: 0.375,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.6-27b": {
			id: "qwen/qwen3.6-27b",
			name: "Qwen: Qwen3.6 27B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.32,
				output: 3.1999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 81920,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.6-35b-a3b": {
			id: "qwen/qwen3.6-35b-a3b",
			name: "Qwen: Qwen3.6 35B A3B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 1,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.6-flash": {
			id: "qwen/qwen3.6-flash",
			name: "Qwen: Qwen3.6 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.1875,
				output: 1.125,
				cacheRead: 0,
				cacheWrite: 0.234375,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.6-plus": {
			id: "qwen/qwen3.6-plus",
			name: "Qwen: Qwen3.6 Plus",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.325,
				output: 1.95,
				cacheRead: 0,
				cacheWrite: 0.40625,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.7-flash": {
			id: "qwen/qwen3.7-flash",
			name: "Qwen: Qwen3.7 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.03,
				output: 0.13,
				cacheRead: 0.006,
				cacheWrite: 0.038000000000000006,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.7-max": {
			id: "qwen/qwen3.7-max",
			name: "Qwen: Qwen3.7 Max",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.475,
				output: 4.425,
				cacheRead: 0.295,
				cacheWrite: 1.84375,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.7-plus": {
			id: "qwen/qwen3.7-plus",
			name: "Qwen: Qwen3.7 Plus",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.32,
				output: 1.28,
				cacheRead: 0.064,
				cacheWrite: 0.39999999999999997,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-2.4t-a95b": {
			id: "qwen/qwen3.8-2.4t-a95b",
			name: "Qwen: Qwen3.8 2.4T A95B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-27b": {
			id: "qwen/qwen3.8-27b",
			name: "Qwen: Qwen3.8 27B",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.425,
				output: 2.5500000000000003,
				cacheRead: 0.08499999999999999,
				cacheWrite: 0.53125,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-flash": {
			id: "qwen/qwen3.8-flash",
			name: "Qwen: Qwen3.8 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.47,
				cacheRead: 0.016,
				cacheWrite: 0.19999999999999998,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-max-0902": {
			id: "qwen/qwen3.8-max-0902",
			name: "Qwen: Qwen3.8 Max (0902)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-max-prime": {
			id: "qwen/qwen3.8-max-prime",
			name: "Qwen: Qwen3.8 Max Prime",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 12,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"qwen/qwen3.8-omni-flash": {
			id: "qwen/qwen3.8-omni-flash",
			name: "Qwen: Qwen3.8 Omni Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.47,
				cacheRead: 0.016,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"rekaai/reka-edge": {
			id: "rekaai/reka-edge",
			name: "Reka Edge",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.09999999999999999,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 16384,
			maxTokens: 14745,
		} satisfies Model<"openai-completions">,
		"relace/relace-search": {
			id: "relace/relace-search",
			name: "Relace: Relace Search",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"sakana/fugu-max": {
			id: "sakana/fugu-max",
			name: "Sakana: Fugu Max",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"sakana/fugu-ultra": {
			id: "sakana/fugu-ultra",
			name: "Sakana: Fugu Ultra",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"sakana/fugu-ultra-v2": {
			id: "sakana/fugu-ultra-v2",
			name: "Sakana: Fugu Ultra v2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"sakana/sakana-namazu": {
			id: "sakana/sakana-namazu",
			name: "Sakana: Sakana Namazu",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"stepfun/step-3.5-flash": {
			id: "stepfun/step-3.5-flash",
			name: "StepFun: Step 3.5 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.09999999999999999,
				output: 0.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"stepfun/step-3.7-flash": {
			id: "stepfun/step-3.7-flash",
			name: "StepFun: Step 3.7 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.15,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 230400,
		} satisfies Model<"openai-completions">,
		"stepfun/step-5-preview": {
			id: "stepfun/step-5-preview",
			name: "StepFun: Step 5 Preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 2.7,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"tencent/hy3": {
			id: "tencent/hy3",
			name: "Tencent: Hy3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.0825,
				output: 0.33,
				cacheRead: 0.020625,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"tencent/hy3-preview": {
			id: "tencent/hy3-preview",
			name: "Tencent: Hy3 preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.18,
				output: 0.6,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 235929,
		} satisfies Model<"openai-completions">,
		"tencent/hy4-preview": {
			id: "tencent/hy4-preview",
			name: "Tencent: Hy4 preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7505999999999999,
				output: 2.2509,
				cacheRead: 0.0378,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 64000,
		} satisfies Model<"openai-completions">,
		"thinkingmachines/inkling": {
			id: "thinkingmachines/inkling",
			name: "Thinking Machines: Inkling",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 4.05,
				cacheRead: 0.16999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 471859,
		} satisfies Model<"openai-completions">,
		"thinkingmachines/inkling-small": {
			id: "thinkingmachines/inkling-small",
			name: "Thinking Machines: Inkling Small",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.44999999999999996,
				output: 1.2,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"thinkingmachines/inkling-small:free": {
			id: "thinkingmachines/inkling-small:free",
			name: "Thinking Machines: Inkling Small (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"thinkingmachines/inkling:free": {
			id: "thinkingmachines/inkling:free",
			name: "Thinking Machines: Inkling (free)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 262144,
		} satisfies Model<"openai-completions">,
		"typesafe/jev-router": {
			id: "typesafe/jev-router",
			name: "TypeSafe: Jev Router",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: -1000000,
				output: -1000000,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 4096,
		} satisfies Model<"openai-completions">,
		"unbiased/pareto": {
			id: "unbiased/pareto",
			name: "Pareto",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 7.5,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"unbiased/pareto-26.10-preview": {
			id: "unbiased/pareto-26.10-preview",
			name: "Pareto 26.10 Preview",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.7999999999999999,
				output: 3.1999999999999997,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"upstage/solar-mini4": {
			id: "upstage/solar-mini4",
			name: "Upstage: Solar Mini 4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.049999999999999996,
				output: 0.19999999999999998,
				cacheRead: 0.005,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"upstage/solar-pro-3": {
			id: "upstage/solar-pro-3",
			name: "Upstage: Solar Pro 3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"upstage/solar-pro4": {
			id: "upstage/solar-pro4",
			name: "Upstage: Solar Pro 4",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.09,
				output: 0.36,
				cacheRead: 0.018,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-4.20": {
			id: "x-ai/grok-4.20",
			name: "SpaceXAI: Grok 4.20",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 1800000,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-4.3": {
			id: "x-ai/grok-4.3",
			name: "SpaceXAI: Grok 4.3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 900000,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-4.3:batch": {
			id: "x-ai/grok-4.3:batch",
			name: "SpaceXAI: Grok 4.3 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 2,
				cacheRead: 0.16,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 900000,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-4.5": {
			id: "x-ai/grok-4.5",
			name: "SpaceXAI: Grok 4.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 450000,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-4.6": {
			id: "x-ai/grok-4.6",
			name: "SpaceXAI: Grok 4.6",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 450000,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-4.7": {
			id: "x-ai/grok-4.7",
			name: "SpaceXAI: Grok 4.7",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 450000,
		} satisfies Model<"openai-completions">,
		"x-ai/grok-build-0.1": {
			id: "x-ai/grok-build-0.1",
			name: "SpaceXAI: Grok Build 0.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 2,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 230400,
		} satisfies Model<"openai-completions">,
		"xiaomi/mimo-v2.5": {
			id: "xiaomi/mimo-v2.5",
			name: "Xiaomi: MiMo-V2.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.0028,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"xiaomi/mimo-v2.5-pro": {
			id: "xiaomi/mimo-v2.5-pro",
			name: "Xiaomi: MiMo-V2.5-Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.0036,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"xiaomi/mimo-v2.6-flash": {
			id: "xiaomi/mimo-v2.6-flash",
			name: "Xiaomi: MiMo-V2.6-Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.0028,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"xiaomi/mimo-v2.6-pro": {
			id: "xiaomi/mimo-v2.6-pro",
			name: "Xiaomi: MiMo-V2.6-Pro",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.0036,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"xiaomi/mimo-v2.6-pro-ultraspeed": {
			id: "xiaomi/mimo-v2.6-pro-ultraspeed",
			name: "Xiaomi: MiMo-V2.6-Pro-UltraSpeed",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.35,
				output: 8.7,
				cacheRead: 0.036,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.5": {
			id: "z-ai/glm-4.5",
			name: "Z.ai: GLM 4.5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 98304,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.5-air": {
			id: "z-ai/glm-4.5-air",
			name: "Z.ai: GLM 4.5 Air",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.13,
				output: 0.85,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 98304,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.5v": {
			id: "z-ai/glm-4.5v",
			name: "Z.ai: GLM 4.5V",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 1.7999999999999998,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 65536,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.6": {
			id: "z-ai/glm-4.6",
			name: "Z.ai: GLM 4.6",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.43,
				output: 1.75,
				cacheRead: 0.08,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 16384,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.6v": {
			id: "z-ai/glm-4.6v",
			name: "Z.ai: GLM 4.6V",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 0.8999999999999999,
				cacheRead: 0.055,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.7": {
			id: "z-ai/glm-4.7",
			name: "Z.ai: GLM 4.7",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-4.7-flash": {
			id: "z-ai/glm-4.7-flash",
			name: "Z.ai: GLM 4.7 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.060500000000000005,
				output: 0.39999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 117964,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5": {
			id: "z-ai/glm-5",
			name: "Z.ai: GLM 5",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 1.92,
				cacheRead: 0.12,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5-turbo": {
			id: "z-ai/glm-5-turbo",
			name: "Z.ai: GLM 5 Turbo",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.2,
				output: 4,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.1": {
			id: "z-ai/glm-5.1",
			name: "Z.ai: GLM 5.1",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.966,
				output: 3.036,
				cacheRead: 0.1794,
				cacheWrite: 0,
			},
			contextWindow: 204800,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.2": {
			id: "z-ai/glm-5.2",
			name: "Z.ai: GLM 5.2",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 6,
				cacheRead: 0.059,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.3": {
			id: "z-ai/glm-5.3",
			name: "Z.ai: GLM 5.3",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.04,
				output: 4.8,
				cacheRead: 0.039,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.3-flash": {
			id: "z-ai/glm-5.3-flash",
			name: "Z.ai: GLM 5.3 Flash",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943717,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.3-flash:batch": {
			id: "z-ai/glm-5.3-flash:batch",
			name: "Z.ai: GLM 5.3 Flash (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.06,
				output: 0.19999999999999998,
				cacheRead: 0.012,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.3-flashx": {
			id: "z-ai/glm-5.3-flashx",
			name: "Z.ai: GLM 5.3 FlashX",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.37,
				output: 1.25,
				cacheRead: 0.09,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.3-prime": {
			id: "z-ai/glm-5.3-prime",
			name: "Z.ai: GLM 5.3 Prime",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.8,
				output: 8.8,
				cacheRead: 0.56,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5.3:batch": {
			id: "z-ai/glm-5.3:batch",
			name: "Z.ai: GLM 5.3 (batch)",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.44999999999999996,
				output: 2,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"z-ai/glm-5v-turbo": {
			id: "z-ai/glm-5v-turbo",
			name: "Z.ai: GLM 5V Turbo",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.2,
				output: 4,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 202752,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
		"~anthropic/claude-fable-latest": {
			id: "~anthropic/claude-fable-latest",
			name: "Anthropic: Claude Fable Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~anthropic/claude-haiku-latest": {
			id: "~anthropic/claude-haiku-latest",
			name: "Anthropic: Claude Haiku Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~anthropic/claude-opus-latest": {
			id: "~anthropic/claude-opus-latest",
			name: "Anthropic: Claude Opus Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.19999999999999998,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~anthropic/claude-sonnet-latest": {
			id: "~anthropic/claude-sonnet-latest",
			name: "Anthropic: Claude Sonnet Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~deepseek/deepseek-flash-latest": {
			id: "~deepseek/deepseek-flash-latest",
			name: "DeepSeek: DeepSeek Flash Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.016,
				output: 1.2,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"~deepseek/deepseek-pro-latest": {
			id: "~deepseek/deepseek-pro-latest",
			name: "DeepSeek: DeepSeek Pro Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.1282,
				output: 8,
				cacheRead: 0.13,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 393216,
		} satisfies Model<"openai-completions">,
		"~deepseek/deepseek-v4-flash-latest": {
			id: "~deepseek/deepseek-v4-flash-latest",
			name: "DeepSeek: DeepSeek V4 Flash Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.0053,
				output: 1.28,
				cacheRead: 0.0053,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"~google/gemini-flash-latest": {
			id: "~google/gemini-flash-latest",
			name: "Google: Gemini Flash Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0.0416666666666667,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"~google/gemini-pro-latest": {
			id: "~google/gemini-pro-latest",
			name: "Google: Gemini Pro Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0.375,
			},
			contextWindow: 1048576,
			maxTokens: 65536,
		} satisfies Model<"openai-completions">,
		"~moonshotai/kimi-latest": {
			id: "~moonshotai/kimi-latest",
			name: "MoonshotAI: Kimi Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.49,
				output: 13,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"~openai/gpt-astra-latest": {
			id: "~openai/gpt-astra-latest",
			name: "OpenAI: GPT Astra Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~openai/gpt-luna-latest": {
			id: "~openai/gpt-luna-latest",
			name: "OpenAI: GPT Luna Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~openai/gpt-mini-latest": {
			id: "~openai/gpt-mini-latest",
			name: "OpenAI: GPT Mini Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~openai/gpt-sol-latest": {
			id: "~openai/gpt-sol-latest",
			name: "OpenAI: GPT Sol Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~openai/gpt-terra-latest": {
			id: "~openai/gpt-terra-latest",
			name: "OpenAI: GPT Terra Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"openai-completions">,
		"~x-ai/grok-latest": {
			id: "~x-ai/grok-latest",
			name: "xAI: Grok Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 450000,
		} satisfies Model<"openai-completions">,
		"~z-ai/glm-flash-latest": {
			id: "~z-ai/glm-flash-latest",
			name: "Z.ai: GLM Flash Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.032,
				output: 0.19297899999999998,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 943718,
		} satisfies Model<"openai-completions">,
		"~z-ai/glm-latest": {
			id: "~z-ai/glm-latest",
			name: "Z.ai: GLM Latest",
			api: "openai-completions",
			provider: "openrouter",
			baseUrl: "https://openrouter.ai/api/v1",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.031200000000000002,
				output: 4.4,
				cacheRead: 0.029,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"openai-completions">,
	},
	"vercel-ai-gateway": {
		"alibaba/qwen-3-14b": {
			id: "alibaba/qwen-3-14b",
			name: "Qwen3-14B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.12,
				output: 0.24,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 40960,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen-3-235b": {
			id: "alibaba/qwen-3-235b",
			name: "Qwen3 235B A22B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.22,
				output: 0.88,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen-3-30b": {
			id: "alibaba/qwen-3-30b",
			name: "Qwen3-30B-A3B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.12,
				output: 0.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 40960,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen-3-32b": {
			id: "alibaba/qwen-3-32b",
			name: "Qwen 3 32B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.16,
				output: 0.64,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen-3.6-max-preview": {
			id: "alibaba/qwen-3.6-max-preview",
			name: "Qwen 3.6 Max Preview",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.3,
				output: 7.8,
				cacheRead: 0.13,
				cacheWrite: 1.625,
			},
			contextWindow: 240000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-235b-a22b-thinking": {
			id: "alibaba/qwen3-235b-a22b-thinking",
			name: "Qwen3 VL 235B A22B Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-coder": {
			id: "alibaba/qwen3-coder",
			name: "Qwen3 Coder 480B A35B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-coder-30b-a3b": {
			id: "alibaba/qwen3-coder-30b-a3b",
			name: "Qwen 3 Coder 30B A3B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-coder-next": {
			id: "alibaba/qwen3-coder-next",
			name: "Qwen3 Coder Next",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.5,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-coder-plus": {
			id: "alibaba/qwen3-coder-plus",
			name: "Qwen3 Coder Plus",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-max": {
			id: "alibaba/qwen3-max",
			name: "Qwen3 Max",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1.2,
				output: 6,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-max-preview": {
			id: "alibaba/qwen3-max-preview",
			name: "Qwen3 Max Preview",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 1.2,
				output: 6,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-max-thinking": {
			id: "alibaba/qwen3-max-thinking",
			name: "Qwen 3 Max Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.2,
				output: 6,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-next-80b-a3b-instruct": {
			id: "alibaba/qwen3-next-80b-a3b-instruct",
			name: "Qwen3 Next 80B A3B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262114,
			maxTokens: 262114,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-next-80b-a3b-thinking": {
			id: "alibaba/qwen3-next-80b-a3b-thinking",
			name: "Qwen3 Next 80B A3B Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 1.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-vl-235b-a22b-instruct": {
			id: "alibaba/qwen3-vl-235b-a22b-instruct",
			name: "Qwen3 VL 235B A22B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 1.5999999999999999,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 129024,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-vl-instruct": {
			id: "alibaba/qwen3-vl-instruct",
			name: "Qwen3 VL 235B A22B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 1.5999999999999999,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 129024,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3-vl-thinking": {
			id: "alibaba/qwen3-vl-thinking",
			name: "Qwen3 VL 235B A22B Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.5-flash": {
			id: "alibaba/qwen3.5-flash",
			name: "Qwen 3.5 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.39999999999999997,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.5-plus": {
			id: "alibaba/qwen3.5-plus",
			name: "Qwen 3.5 Plus",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 2.4,
				cacheRead: 0.04,
				cacheWrite: 0.5,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.6-27b": {
			id: "alibaba/qwen3.6-27b",
			name: "Qwen 3.6 27B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3.5999999999999996,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.6-plus": {
			id: "alibaba/qwen3.6-plus",
			name: "Qwen 3.6 Plus",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0.625,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.7-flash": {
			id: "alibaba/qwen3.7-flash",
			name: "Qwen 3.7 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.03,
				output: 0.13,
				cacheRead: 0.006,
				cacheWrite: 0.038000000000000006,
			},
			contextWindow: 991000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.7-max": {
			id: "alibaba/qwen3.7-max",
			name: "Qwen 3.7 Max",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 7.5,
				cacheRead: 0.5,
				cacheWrite: 3.125,
			},
			contextWindow: 991000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.7-plus": {
			id: "alibaba/qwen3.7-plus",
			name: "Qwen 3.7 Plus",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 1.5999999999999999,
				cacheRead: 0.08,
				cacheWrite: 0.5,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-2.4t-a95b": {
			id: "alibaba/qwen3.8-2.4t-a95b",
			name: "Qwen3.8 2.4T A95B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-27b": {
			id: "alibaba/qwen3.8-27b",
			name: "Qwen3.8 27B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0.625,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-flash": {
			id: "alibaba/qwen3.8-flash",
			name: "Qwen 3.8 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.47,
				cacheRead: 0.016,
				cacheWrite: 0.19999999999999998,
			},
			contextWindow: 991000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-max": {
			id: "alibaba/qwen3.8-max",
			name: "Qwen 3.8 Max",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-max-0902": {
			id: "alibaba/qwen3.8-max-0902",
			name: "Qwen3.8 Max 0902",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 2.5,
			},
			contextWindow: 991000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-max-prime": {
			id: "alibaba/qwen3.8-max-prime",
			name: "Qwen 3.8 Max Prime",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 12,
				cacheRead: 0.5,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"alibaba/qwen3.8-omni-flash": {
			id: "alibaba/qwen3.8-omni-flash",
			name: "Qwen 3.8 Omni Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.47,
				cacheRead: 0.016,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"amazon/nova-2-lite": {
			id: "amazon/nova-2-lite",
			name: "Nova 2 Lite",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"amazon/nova-lite": {
			id: "amazon/nova-lite",
			name: "Nova Lite",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.06,
				output: 0.24,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 300000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"amazon/nova-micro": {
			id: "amazon/nova-micro",
			name: "Nova Micro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.035,
				output: 0.14,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"amazon/nova-pro": {
			id: "amazon/nova-pro",
			name: "Nova Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.7999999999999999,
				output: 3.1999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 300000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-3-haiku": {
			id: "anthropic/claude-3-haiku",
			name: "Claude 3 Haiku",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.25,
				cacheRead: 0.03,
				cacheWrite: 0.3,
			},
			contextWindow: 200000,
			maxTokens: 4096,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-fable-5": {
			id: "anthropic/claude-fable-5",
			name: "Claude Fable 5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-fable-5.1": {
			id: "anthropic/claude-fable-5.1",
			name: "Claude Fable 5.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 0.25,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-haiku-4.5": {
			id: "anthropic/claude-haiku-4.5",
			name: "Claude Haiku 4.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 1.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-haiku-5.5": {
			id: "anthropic/claude-haiku-5.5",
			name: "Claude Haiku 5.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-4": {
			id: "anthropic/claude-opus-4",
			name: "Claude Opus 4",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 75,
				cacheRead: 1.5,
				cacheWrite: 18.75,
			},
			contextWindow: 200000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-4.5": {
			id: "anthropic/claude-opus-4.5",
			name: "Claude Opus 4.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 200000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-4.6": {
			id: "anthropic/claude-opus-4.6",
			name: "Claude Opus 4.6",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-4.7": {
			id: "anthropic/claude-opus-4.7",
			name: "Claude Opus 4.7",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-4.8": {
			id: "anthropic/claude-opus-4.8",
			name: "Claude Opus 4.8",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-4.8-fast": {
			id: "anthropic/claude-opus-4.8-fast",
			name: "Claude Opus 4.8 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-5": {
			id: "anthropic/claude-opus-5",
			name: "Claude Opus 5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 25,
				cacheRead: 0.5,
				cacheWrite: 6.25,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-5-fast": {
			id: "anthropic/claude-opus-5-fast",
			name: "Claude Opus 5 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-5.5": {
			id: "anthropic/claude-opus-5.5",
			name: "Claude Opus 5.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.19999999999999998,
				cacheWrite: 5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-opus-5.5-fast": {
			id: "anthropic/claude-opus-5.5-fast",
			name: "Claude Opus 5.5 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 8,
				output: 40,
				cacheRead: 0.39999999999999997,
				cacheWrite: 10,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-sonnet-4": {
			id: "anthropic/claude-sonnet-4",
			name: "Claude Sonnet 4",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-sonnet-4.5": {
			id: "anthropic/claude-sonnet-4.5",
			name: "Claude Sonnet 4.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-sonnet-4.6": {
			id: "anthropic/claude-sonnet-4.6",
			name: "Claude Sonnet 4.6",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 3.75,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-sonnet-5": {
			id: "anthropic/claude-sonnet-5",
			name: "Claude Sonnet 5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"anthropic/claude-sonnet-5.5": {
			id: "anthropic/claude-sonnet-5.5",
			name: "Claude Sonnet 5.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"arcee-ai/trinity-large-thinking": {
			id: "arcee-ai/trinity-large-thinking",
			name: "Trinity Large Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.7999999999999999,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262100,
			maxTokens: 80000,
		} satisfies Model<"anthropic-messages">,
		"bytedance/seed-1.6": {
			id: "bytedance/seed-1.6",
			name: "Seed 1.6",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"bytedance/seed-1.8": {
			id: "bytedance/seed-1.8",
			name: "Bytedance Seed 1.8",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"bytedance/seed-2.1-turbo": {
			id: "bytedance/seed-2.1-turbo",
			name: "Seed 2.1 Turbo",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 2.5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"anthropic-messages">,
		"callstack/apex": {
			id: "callstack/apex",
			name: "Apex",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"cohere/command-a": {
			id: "cohere/command-a",
			name: "Command A",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 8000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-r1": {
			id: "deepseek/deepseek-r1",
			name: "DeepSeek-R1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.35,
				output: 5.4,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v3.1": {
			id: "deepseek/deepseek-v3.1",
			name: "DeepSeek V3.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.95,
				cacheRead: 0.13,
				cacheWrite: 0,
			},
			contextWindow: 163840,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v3.2": {
			id: "deepseek/deepseek-v3.2",
			name: "DeepSeek V3.2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.62,
				output: 1.85,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v3.2-thinking": {
			id: "deepseek/deepseek-v3.2-thinking",
			name: "DeepSeek V3.2 Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.62,
				output: 1.85,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v4-flash": {
			id: "deepseek/deepseek-v4-flash",
			name: "DeepSeek V4 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.13,
				output: 0.26,
				cacheRead: 0.028,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v4-flash-0731": {
			id: "deepseek/deepseek-v4-flash-0731",
			name: "DeepSeek V4 Flash 0731",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07600000000000001,
				output: 0.153,
				cacheRead: 0.014,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v4-flash-vision-exp": {
			id: "deepseek/deepseek-v4-flash-vision-exp",
			name: "DeepSeek V4 Flash Vision Exp",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.21559999999999999,
				output: 0.6468,
				cacheRead: 0.0068,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v4-pro": {
			id: "deepseek/deepseek-v4-pro",
			name: "DeepSeek V4 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.66,
				output: 1.9800000000000002,
				cacheRead: 0.022,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v4-pro-0813": {
			id: "deepseek/deepseek-v4-pro-0813",
			name: "DeepSeek V4 Pro 0813",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.66,
				output: 1.9800000000000002,
				cacheRead: 0.06599999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 384000,
		} satisfies Model<"anthropic-messages">,
		"deepseek/deepseek-v4.1-flash": {
			id: "deepseek/deepseek-v4.1-flash",
			name: "DeepSeek V4.1 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.007,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"fireworks/ember-1": {
			id: "fireworks/ember-1",
			name: "Ember-1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-2.5-flash": {
			id: "google/gemini-2.5-flash",
			name: "Gemini 2.5 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-2.5-flash-lite": {
			id: "google/gemini-2.5-flash-lite",
			name: "Gemini 2.5 Flash Lite",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.39999999999999997,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-2.5-pro": {
			id: "google/gemini-2.5-pro",
			name: "Gemini 2.5 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 65535,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3-flash": {
			id: "google/gemini-3-flash",
			name: "Gemini 3 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 3,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65000,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.1-flash-lite": {
			id: "google/gemini-3.1-flash-lite",
			name: "Gemini 3.1 Flash Lite",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65000,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.1-pro-preview": {
			id: "google/gemini-3.1-pro-preview",
			name: "Gemini 3.1 Pro Preview",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.5-flash": {
			id: "google/gemini-3.5-flash",
			name: "Gemini 3.5 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 9,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.5-flash-lite": {
			id: "google/gemini-3.5-flash-lite",
			name: "Gemini 3.5 Flash Lite",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 2.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65000,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.6-flash": {
			id: "google/gemini-3.6-flash",
			name: "Gemini 3.6 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.7-flash": {
			id: "google/gemini-3.7-flash",
			name: "Gemini 3.7 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"anthropic-messages">,
		"google/gemini-3.8-flash": {
			id: "google/gemini-3.8-flash",
			name: "Gemini 3.8 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 3.75,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65535,
		} satisfies Model<"anthropic-messages">,
		"google/gemma-4-26b-a4b-it": {
			id: "google/gemma-4-26b-a4b-it",
			name: "Google Gemma 4 26B A4B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"google/gemma-4-31b-it": {
			id: "google/gemma-4-31b-it",
			name: "Gemma 4 31B IT",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.39999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"inception/mercury-2": {
			id: "inception/mercury-2",
			name: "Mercury 2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 0.75,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"inception/mercury-2.5": {
			id: "inception/mercury-2.5",
			name: "Mercury 2.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.04,
				output: 0.15,
				cacheRead: 0.004,
				cacheWrite: 0,
			},
			contextWindow: 260000,
			maxTokens: 65536,
		} satisfies Model<"anthropic-messages">,
		"inception/mercury-coder-small": {
			id: "inception/mercury-coder-small",
			name: "Mercury Coder Small Beta",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.25,
				output: 1,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 32000,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"inclusionai/ling-3.0-flash": {
			id: "inclusionai/ling-3.0-flash",
			name: "Ling 3.0 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.020999999999999998,
				output: 0.063,
				cacheRead: 0.004200000000000001,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"inclusionai/ling-3.0-flash-fin": {
			id: "inclusionai/ling-3.0-flash-fin",
			name: "Ling 3.0 Flash Fin",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.075,
				output: 0.22,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"inclusionai/ling-3.0-flash-sante": {
			id: "inclusionai/ling-3.0-flash-sante",
			name: "Ling 3.0 Flash Sante",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.075,
				output: 0.22,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"inclusionai/ling-3.0-flash-vl": {
			id: "inclusionai/ling-3.0-flash-vl",
			name: "Ling 3.0 Flash VL",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.075,
				output: 0.22,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"inclusionai/ling-3.1-flash": {
			id: "inclusionai/ling-3.1-flash",
			name: "Ling 3.1 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"inclusionai/ling-3.1-flash-free": {
			id: "inclusionai/ling-3.1-flash-free",
			name: "Ling 3.1 Flash (Free)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"interfaze/interfaze-beta": {
			id: "interfaze/interfaze-beta",
			name: "Interfaze Beta",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 3.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"meituan/longcat-2.5-preview": {
			id: "meituan/longcat-2.5-preview",
			name: "LongCat 2.5 Preview",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.006,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"meta/llama-3.1-70b": {
			id: "meta/llama-3.1-70b",
			name: "Llama 3.1 70B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.72,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"meta/llama-3.1-8b": {
			id: "meta/llama-3.1-8b",
			name: "Llama 3.1 8B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.22,
				output: 0.22,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"meta/llama-3.3-70b": {
			id: "meta/llama-3.3-70b",
			name: "Llama 3.3 70B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.72,
				output: 0.72,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"meta/llama-4-maverick": {
			id: "meta/llama-4-maverick",
			name: "Llama 4 Maverick 17B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.24,
				output: 0.9700000000000001,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"meta/llama-4-scout": {
			id: "meta/llama-4-scout",
			name: "Llama 4 Scout 17B Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.16999999999999998,
				output: 0.66,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"meta/muse-glimmer-30b": {
			id: "meta/muse-glimmer-30b",
			name: "Muse Glimmer 30B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.35,
				output: 1.5,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"meta/muse-spark-1.1": {
			id: "meta/muse-spark-1.1",
			name: "Muse Spark 1.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"meta/muse-spark-1.2": {
			id: "meta/muse-spark-1.2",
			name: "Muse Spark 1.2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"meta/muse-spark-1.2-contributor": {
			id: "meta/muse-spark-1.2-contributor",
			name: "Muse Spark 1.2 Contributor",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.19999999999999998,
				cacheRead: 0.002,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"meta/muse-spark-1.3": {
			id: "meta/muse-spark-1.3",
			name: "Muse Spark 1.3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 4.25,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"meta/muse-spark-1.3-contributor": {
			id: "meta/muse-spark-1.3-contributor",
			name: "Muse Spark 1.3 Contributor",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.19999999999999998,
				cacheRead: 0.002,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 1048576,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2": {
			id: "minimax/minimax-m2",
			name: "MiniMax M2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.03,
				cacheWrite: 0.375,
			},
			contextWindow: 205000,
			maxTokens: 205000,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2.1": {
			id: "minimax/minimax-m2.1",
			name: "MiniMax M2.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.03,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2.1-lightning": {
			id: "minimax/minimax-m2.1-lightning",
			name: "MiniMax M2.1 Lightning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 2.4,
				cacheRead: 0.03,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2.5": {
			id: "minimax/minimax-m2.5",
			name: "MiniMax M2.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.03,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131000,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2.5-highspeed": {
			id: "minimax/minimax-m2.5-highspeed",
			name: "MiniMax M2.5 High Speed",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.4,
				cacheRead: 0.03,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131000,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2.7": {
			id: "minimax/minimax-m2.7",
			name: "MiniMax M2.7",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131000,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m2.7-highspeed": {
			id: "minimax/minimax-m2.7-highspeed",
			name: "MiniMax M2.7 High Speed",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.4,
				cacheRead: 0.06,
				cacheWrite: 0.375,
			},
			contextWindow: 204800,
			maxTokens: 131100,
		} satisfies Model<"anthropic-messages">,
		"minimax/minimax-m3": {
			id: "minimax/minimax-m3",
			name: "MiniMax M3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.3,
				output: 1.2,
				cacheRead: 0.06,
				cacheWrite: 0,
			},
			contextWindow: 512000,
			maxTokens: 512000,
		} satisfies Model<"anthropic-messages">,
		"mistral/codestral": {
			id: "mistral/codestral",
			name: "Mistral Codestral",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 0.8999999999999999,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4000,
		} satisfies Model<"anthropic-messages">,
		"mistral/ministral-14b": {
			id: "mistral/ministral-14b",
			name: "Ministral 14B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.19999999999999998,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"mistral/ministral-3b": {
			id: "mistral/ministral-3b",
			name: "Ministral 3B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.09999999999999999,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 4000,
		} satisfies Model<"anthropic-messages">,
		"mistral/ministral-8b": {
			id: "mistral/ministral-8b",
			name: "Ministral 8B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.15,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 4000,
		} satisfies Model<"anthropic-messages">,
		"mistral/mistral-large-3": {
			id: "mistral/mistral-large-3",
			name: "Mistral Large 3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"mistral/mistral-large-4": {
			id: "mistral/mistral-large-4",
			name: "Mistral Large 4",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6799999999999999,
				output: 2.09,
				cacheRead: 0.07,
				cacheWrite: 0,
			},
			contextWindow: 524288,
			maxTokens: 262144,
		} satisfies Model<"anthropic-messages">,
		"mistral/mistral-medium-3.5": {
			id: "mistral/mistral-medium-3.5",
			name: "Mistral Medium Latest",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 7.5,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"mistral/mistral-nemo": {
			id: "mistral/mistral-nemo",
			name: "Mistral Nemo 12B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.019000000000000003,
				output: 0.03,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"mistral/mistral-small": {
			id: "mistral/mistral-small",
			name: "Mistral Small",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.015,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 4000,
		} satisfies Model<"anthropic-messages">,
		"mixedbread/toast-1": {
			id: "mixedbread/toast-1",
			name: "Toast 1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.3,
				output: 0.72,
				cacheRead: 0.036,
				cacheWrite: 0,
			},
			contextWindow: 131000,
			maxTokens: 4000,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k2": {
			id: "moonshotai/kimi-k2",
			name: "Kimi K2 Instruct",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.5700000000000001,
				output: 2.3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k2.5": {
			id: "moonshotai/kimi-k2.5",
			name: "Kimi K2.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 3,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k2.6": {
			id: "moonshotai/kimi-k2.6",
			name: "Kimi K2.6",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.16,
				cacheWrite: 0,
			},
			contextWindow: 262000,
			maxTokens: 262000,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k2.7-code": {
			id: "moonshotai/kimi-k2.7-code",
			name: "Kimi K2.7 Code",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.19,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k2.7-code-highspeed": {
			id: "moonshotai/kimi-k2.7-code-highspeed",
			name: "Kimi K2.7 Code High Speed",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.9,
				output: 8,
				cacheRead: 0.38,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k3": {
			id: "moonshotai/kimi-k3",
			name: "Kimi K3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3,
				output: 15,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"moonshotai/kimi-k3-fast": {
			id: "moonshotai/kimi-k3-fast",
			name: "Kimi K3 Fast",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.5,
				output: 22.5,
				cacheRead: 0.44999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"nvidia/nemotron-3-nano-30b-a3b": {
			id: "nvidia/nemotron-3-nano-30b-a3b",
			name: "Nemotron 3 Nano 30B A3B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.049999999999999996,
				output: 0.19999999999999998,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"anthropic-messages">,
		"nvidia/nemotron-3-super-120b-a12b": {
			id: "nvidia/nemotron-3-super-120b-a12b",
			name: "NVIDIA Nemotron 3 Super 120B A12B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.65,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32000,
		} satisfies Model<"anthropic-messages">,
		"nvidia/nemotron-3-ultra-550b-a55b": {
			id: "nvidia/nemotron-3-ultra-550b-a55b",
			name: "Nemotron 3 Ultra",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.4,
				cacheRead: 0.12,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 65000,
		} satisfies Model<"anthropic-messages">,
		"nvidia/nemotron-3.5-lightning": {
			id: "nvidia/nemotron-3.5-lightning",
			name: "Nemotron 3.5 Lightning 30B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.049999999999999996,
				output: 0.19999999999999998,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"nvidia/nemotron-nano-12b-v2-vl": {
			id: "nvidia/nemotron-nano-12b-v2-vl",
			name: "Nvidia Nemotron Nano 12B V2 VL",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"nvidia/nemotron-nano-9b-v2": {
			id: "nvidia/nemotron-nano-9b-v2",
			name: "Nvidia Nemotron Nano 9B V2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.22999999999999998,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-3.5-turbo": {
			id: "openai/gpt-3.5-turbo",
			name: "GPT-3.5 Turbo",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.5,
				output: 1.5,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 16385,
			maxTokens: 4096,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4-turbo": {
			id: "openai/gpt-4-turbo",
			name: "GPT-4 Turbo",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 30,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 4096,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4.1": {
			id: "openai/gpt-4.1",
			name: "GPT-4.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4.1-fast": {
			id: "openai/gpt-4.1-fast",
			name: "GPT-4.1 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 3.5,
				output: 14,
				cacheRead: 0.875,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4.1-mini": {
			id: "openai/gpt-4.1-mini",
			name: "GPT-4.1 mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 1.5999999999999999,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4.1-mini-fast": {
			id: "openai/gpt-4.1-mini-fast",
			name: "GPT-4.1 mini (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.7,
				output: 2.8,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4.1-nano": {
			id: "openai/gpt-4.1-nano",
			name: "GPT-4.1 nano",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.39999999999999997,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4.1-nano-fast": {
			id: "openai/gpt-4.1-nano-fast",
			name: "GPT-4.1 nano (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.7999999999999999,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1047576,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4o": {
			id: "openai/gpt-4o",
			name: "GPT-4o",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 10,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4o-fast": {
			id: "openai/gpt-4o-fast",
			name: "GPT-4o (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 4.25,
				output: 17,
				cacheRead: 2.125,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4o-mini": {
			id: "openai/gpt-4o-mini",
			name: "GPT-4o mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-4o-mini-fast": {
			id: "openai/gpt-4o-mini-fast",
			name: "GPT-4o mini (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 1,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16384,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5": {
			id: "openai/gpt-5",
			name: "GPT-5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5-codex": {
			id: "openai/gpt-5-codex",
			name: "GPT-5-Codex",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.13,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5-fast": {
			id: "openai/gpt-5-fast",
			name: "GPT-5 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 20,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5-mini": {
			id: "openai/gpt-5-mini",
			name: "GPT-5 mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.024999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5-mini-fast": {
			id: "openai/gpt-5-mini-fast",
			name: "GPT-5 mini (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.44999999999999996,
				output: 3.5999999999999996,
				cacheRead: 0.045,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5-nano": {
			id: "openai/gpt-5-nano",
			name: "GPT-5 nano",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.049999999999999996,
				output: 0.39999999999999997,
				cacheRead: 0.005,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5-pro": {
			id: "openai/gpt-5-pro",
			name: "GPT-5 pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 120,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 272000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.1-codex": {
			id: "openai/gpt-5.1-codex",
			name: "GPT-5.1-Codex",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.13,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.1-codex-max": {
			id: "openai/gpt-5.1-codex-max",
			name: "GPT 5.1 Codex Max",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.1-codex-mini": {
			id: "openai/gpt-5.1-codex-mini",
			name: "GPT 5.1 Codex Mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.25,
				output: 2,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.1-thinking": {
			id: "openai/gpt-5.1-thinking",
			name: "GPT 5.1 Thinking",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 10,
				cacheRead: 0.125,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.1-thinking-fast": {
			id: "openai/gpt-5.1-thinking-fast",
			name: "GPT 5.1 Thinking (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 20,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.2": {
			id: "openai/gpt-5.2",
			name: "GPT 5.2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.2-codex": {
			id: "openai/gpt-5.2-codex",
			name: "GPT 5.2 Codex",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.2-fast": {
			id: "openai/gpt-5.2-fast",
			name: "GPT 5.2 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.5,
				output: 28,
				cacheRead: 0.35,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.2-pro": {
			id: "openai/gpt-5.2-pro",
			name: "GPT 5.2 ",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 21,
				output: 168,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.3-codex": {
			id: "openai/gpt-5.3-codex",
			name: "GPT 5.3 Codex",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.75,
				output: 14,
				cacheRead: 0.175,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.3-codex-fast": {
			id: "openai/gpt-5.3-codex-fast",
			name: "GPT 5.3 Codex (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.5,
				output: 28,
				cacheRead: 0.35,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.4": {
			id: "openai/gpt-5.4",
			name: "GPT 5.4",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2.5,
				output: 15,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.4-fast": {
			id: "openai/gpt-5.4-fast",
			name: "GPT 5.4 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.4-mini": {
			id: "openai/gpt-5.4-mini",
			name: "GPT 5.4 Mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.75,
				output: 4.5,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.4-mini-fast": {
			id: "openai/gpt-5.4-mini-fast",
			name: "GPT 5.4 Mini (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.5,
				output: 9,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.4-nano": {
			id: "openai/gpt-5.4-nano",
			name: "GPT 5.4 Nano",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.25,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 400000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.4-pro": {
			id: "openai/gpt-5.4-pro",
			name: "GPT 5.4 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.5": {
			id: "openai/gpt-5.5",
			name: "GPT 5.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.5-fast": {
			id: "openai/gpt-5.5-fast",
			name: "GPT 5.5 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 12.5,
				output: 75,
				cacheRead: 1.25,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.5-pro": {
			id: "openai/gpt-5.5-pro",
			name: "GPT 5.5 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 30,
				output: 180,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.6-luna": {
			id: "openai/gpt-5.6-luna",
			name: "GPT 5.6 Luna",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.2,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.6-luna-fast": {
			id: "openai/gpt-5.6-luna-fast",
			name: "GPT 5.6 Luna (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.39999999999999997,
				output: 2.4,
				cacheRead: 0.04,
				cacheWrite: 0.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.6-sol": {
			id: "openai/gpt-5.6-sol",
			name: "GPT 5.6 Sol",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.39999999999999997,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.6-sol-fast": {
			id: "openai/gpt-5.6-sol-fast",
			name: "GPT 5.6 Sol (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 8,
				output: 40,
				cacheRead: 0.7999999999999999,
				cacheWrite: 10,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.6-terra": {
			id: "openai/gpt-5.6-terra",
			name: "GPT 5.6 Terra",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 12,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-5.6-terra-fast": {
			id: "openai/gpt-5.6-terra-fast",
			name: "GPT 5.6 Terra (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 24,
				cacheRead: 0.39999999999999997,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6-astra": {
			id: "openai/gpt-6-astra",
			name: "GPT-6 Astra",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 10,
				output: 50,
				cacheRead: 1,
				cacheWrite: 12.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6-astra-fast": {
			id: "openai/gpt-6-astra-fast",
			name: "GPT-6 Astra (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 20,
				output: 100,
				cacheRead: 2,
				cacheWrite: 25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6-luna": {
			id: "openai/gpt-6-luna",
			name: "GPT-6 Luna",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.01,
				cacheWrite: 0.125,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6-luna-fast": {
			id: "openai/gpt-6-luna-fast",
			name: "GPT-6 Luna (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1,
				cacheRead: 0.02,
				cacheWrite: 0.25,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6-sol": {
			id: "openai/gpt-6-sol",
			name: "GPT-6 Sol",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.19999999999999998,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6-sol-fast": {
			id: "openai/gpt-6-sol-fast",
			name: "GPT-6 Sol (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.39999999999999997,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6.1-sol": {
			id: "openai/gpt-6.1-sol",
			name: "GPT-6.1 Sol",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 10,
				cacheRead: 0.09999999999999999,
				cacheWrite: 2.5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-6.1-sol-fast": {
			id: "openai/gpt-6.1-sol-fast",
			name: "GPT-6.1 Sol (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.19999999999999998,
				cacheWrite: 5,
			},
			contextWindow: 1050000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-oss-120b": {
			id: "openai/gpt-oss-120b",
			name: "GPT OSS 120B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.09999999999999999,
				output: 0.5,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-oss-20b": {
			id: "openai/gpt-oss-20b",
			name: "GPT OSS 20B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.03,
				output: 0.14,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 131072,
			maxTokens: 8192,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-oss-safeguard-120b": {
			id: "openai/gpt-oss-safeguard-120b",
			name: "GPT OSS Safeguard 120B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.15,
				output: 0.6,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16000,
		} satisfies Model<"anthropic-messages">,
		"openai/gpt-oss-safeguard-20b": {
			id: "openai/gpt-oss-safeguard-20b",
			name: "GPT OSS Safeguard 20B",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.19999999999999998,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 16000,
		} satisfies Model<"anthropic-messages">,
		"openai/o1": {
			id: "openai/o1",
			name: "o1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 15,
				output: 60,
				cacheRead: 7.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"openai/o3": {
			id: "openai/o3",
			name: "o3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"openai/o3-fast": {
			id: "openai/o3-fast",
			name: "o3 (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 3.5,
				output: 14,
				cacheRead: 0.875,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"openai/o3-mini": {
			id: "openai/o3-mini",
			name: "o3-mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.55,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"openai/o3-pro": {
			id: "openai/o3-pro",
			name: "o3 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 20,
				output: 80,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"openai/o4-mini": {
			id: "openai/o4-mini",
			name: "o4-mini",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.1,
				output: 4.4,
				cacheRead: 0.275,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"openai/o4-mini-fast": {
			id: "openai/o4-mini-fast",
			name: "o4-mini (Fast)",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 8,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 100000,
		} satisfies Model<"anthropic-messages">,
		"poolside/laguna-s-2.1": {
			id: "poolside/laguna-s-2.1",
			name: "Laguna S 2.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.09,
				output: 0.18,
				cacheRead: 0.009,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"poolside/laguna-s-2.1-free": {
			id: "poolside/laguna-s-2.1-free",
			name: "Laguna S 2.1 Free",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 32768,
		} satisfies Model<"anthropic-messages">,
		"quiverai/arrow-2": {
			id: "quiverai/arrow-2",
			name: "Arrow 2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4,
				output: 20,
				cacheRead: 0.39999999999999997,
				cacheWrite: 5,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"quiverai/arrow-2-telos": {
			id: "quiverai/arrow-2-telos",
			name: "Arrow 2 Telos",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 6,
				output: 30,
				cacheRead: 0.6,
				cacheWrite: 7.5,
			},
			contextWindow: 131072,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"sakana/fugu-max": {
			id: "sakana/fugu-max",
			name: "Fugu Max",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.25,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"sakana/fugu-ultra": {
			id: "sakana/fugu-ultra",
			name: "Fugu Ultra",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"sakana/fugu-ultra-v2": {
			id: "sakana/fugu-ultra-v2",
			name: "Fugu Ultra v2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 5,
				output: 30,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"sakana/namazu": {
			id: "sakana/namazu",
			name: "Sakana Namazu",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.95,
				output: 4,
				cacheRead: 0.15,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.1-fast-non-reasoning": {
			id: "spacexai/grok-4.1-fast-non-reasoning",
			name: "Grok 4.1 Fast Non-Reasoning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.1-fast-reasoning": {
			id: "spacexai/grok-4.1-fast-reasoning",
			name: "Grok 4.1 Fast Reasoning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 0.5,
				cacheRead: 0.049999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.20-multi-agent": {
			id: "spacexai/grok-4.20-multi-agent",
			name: "Grok 4.20 Multi-Agent",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 2000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.20-multi-agent-beta": {
			id: "spacexai/grok-4.20-multi-agent-beta",
			name: "Grok 4.20 Multi Agent Beta",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 2000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.20-non-reasoning": {
			id: "spacexai/grok-4.20-non-reasoning",
			name: "Grok 4.20 Non-Reasoning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 2000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.20-non-reasoning-beta": {
			id: "spacexai/grok-4.20-non-reasoning-beta",
			name: "Grok 4.20 Beta Non-Reasoning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 2000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.20-reasoning": {
			id: "spacexai/grok-4.20-reasoning",
			name: "Grok 4.20 Reasoning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 2000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.20-reasoning-beta": {
			id: "spacexai/grok-4.20-reasoning-beta",
			name: "Grok 4.20 Beta Reasoning",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 2000000,
			maxTokens: 2000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.3": {
			id: "spacexai/grok-4.3",
			name: "Grok 4.3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.5": {
			id: "spacexai/grok-4.5",
			name: "Grok 4.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.6": {
			id: "spacexai/grok-4.6",
			name: "Grok 4.6",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-4.7": {
			id: "spacexai/grok-4.7",
			name: "Grok 4.7",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"anthropic-messages">,
		"spacexai/grok-build-0.1": {
			id: "spacexai/grok-build-0.1",
			name: "Grok Build 0.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 2,
				cacheRead: 0.19999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"stealth/glyph-cluster": {
			id: "stealth/glyph-cluster",
			name: "Glyph Cluster",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0,
				output: 0,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"stepfun/step-3.7-flash": {
			id: "stepfun/step-3.7-flash",
			name: "Step 3.7 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.19999999999999998,
				output: 1.15,
				cacheRead: 0.04,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"tencent/hy3": {
			id: "tencent/hy3",
			name: "Hy3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.14,
				output: 0.58,
				cacheRead: 0.035,
				cacheWrite: 0,
			},
			contextWindow: 262144,
			maxTokens: 262144,
		} satisfies Model<"anthropic-messages">,
		"tencent/hy4-preview": {
			id: "tencent/hy4-preview",
			name: "Tencent Hy4 Preview",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.834,
				output: 2.501,
				cacheRead: 0.041999999999999996,
				cacheWrite: 0,
			},
			contextWindow: 1024000,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"thinkingmachines/inkling": {
			id: "thinkingmachines/inkling",
			name: "Inkling",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 4.05,
				cacheRead: 0.16999999999999998,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"anthropic-messages">,
		"thinkingmachines/inkling-small": {
			id: "thinkingmachines/inkling-small",
			name: "Inkling Small",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.44999999999999996,
				output: 1.2,
				cacheRead: 0.09999999999999999,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"xiaomi/mimo-v2.5": {
			id: "xiaomi/mimo-v2.5",
			name: "MiMo M2.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.0028,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 131100,
		} satisfies Model<"anthropic-messages">,
		"xiaomi/mimo-v2.5-pro": {
			id: "xiaomi/mimo-v2.5-pro",
			name: "MiMo V2.5 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.0036,
				cacheWrite: 0,
			},
			contextWindow: 1050000,
			maxTokens: 131000,
		} satisfies Model<"anthropic-messages">,
		"xiaomi/mimo-v2.6-flash": {
			id: "xiaomi/mimo-v2.6-flash",
			name: "MiMo V2.6 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.14,
				output: 0.28,
				cacheRead: 0.0028,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"xiaomi/mimo-v2.6-pro": {
			id: "xiaomi/mimo-v2.6-pro",
			name: "MiMo V2.6 Pro",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.435,
				output: 0.87,
				cacheRead: 0.0036,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"xiaomi/mimo-v2.6-pro-ultraspeed": {
			id: "xiaomi/mimo-v2.6-pro-ultraspeed",
			name: "MiMo V2.6 Pro UltraSpeed",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 4.35,
				output: 8.7,
				cacheRead: 0.036,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.5": {
			id: "zai/glm-4.5",
			name: "GLM 4.5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 96000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.5-air": {
			id: "zai/glm-4.5-air",
			name: "GLM 4.5 Air",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.19999999999999998,
				output: 1.1,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 128000,
			maxTokens: 96000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.5v": {
			id: "zai/glm-4.5v",
			name: "GLM 4.5V",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.6,
				output: 1.7999999999999998,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 66000,
			maxTokens: 16000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.6": {
			id: "zai/glm-4.6",
			name: "GLM 4.6",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0.11,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 96000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.7": {
			id: "zai/glm-4.7",
			name: "GLM 4.7",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.6,
				output: 2.2,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 120000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.7-flash": {
			id: "zai/glm-4.7-flash",
			name: "GLM 4.7 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.07,
				output: 0.39999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 131000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-4.7-flashx": {
			id: "zai/glm-4.7-flashx",
			name: "GLM 4.7 FlashX",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.06,
				output: 0.39999999999999997,
				cacheRead: 0.01,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5": {
			id: "zai/glm-5",
			name: "GLM 5",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1,
				output: 3.1999999999999997,
				cacheRead: 0,
				cacheWrite: 0,
			},
			contextWindow: 202800,
			maxTokens: 131100,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5-turbo": {
			id: "zai/glm-5-turbo",
			name: "GLM 5 Turbo",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.2,
				output: 4,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 202800,
			maxTokens: 131100,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.1": {
			id: "zai/glm-5.1",
			name: "GLM 5.1",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.26,
				cacheWrite: 0,
			},
			contextWindow: 202800,
			maxTokens: 64000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.2": {
			id: "zai/glm-5.2",
			name: "GLM 5.2",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 0.7999999999999999,
				output: 2.5500000000000003,
				cacheRead: 0.16,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.2-fast": {
			id: "zai/glm-5.2-fast",
			name: "GLM 5.2 Fast",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.8,
				output: 8.8,
				cacheRead: 0.56,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.3": {
			id: "zai/glm-5.3",
			name: "GLM 5.3",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 1.4,
				output: 4.4,
				cacheRead: 0.14,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 1000000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.3-fast": {
			id: "zai/glm-5.3-fast",
			name: "GLM 5.3 Fast",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text"],
			cost: {
				input: 2.0999999999999996,
				output: 6.6000000000000005,
				cacheRead: 0.21,
				cacheWrite: 0,
			},
			contextWindow: 1048576,
			maxTokens: 262144,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.3-flash": {
			id: "zai/glm-5.3-flash",
			name: "GLM 5.3 Flash",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.15,
				output: 0.5,
				cacheRead: 0.03,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131000,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5.3-flashx": {
			id: "zai/glm-5.3-flashx",
			name: "GLM 5.3 FlashX",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 0.37,
				output: 1.25,
				cacheRead: 0.075,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 131072,
		} satisfies Model<"anthropic-messages">,
		"zai/glm-5v-turbo": {
			id: "zai/glm-5v-turbo",
			name: "GLM 5V Turbo",
			api: "anthropic-messages",
			provider: "vercel-ai-gateway",
			baseUrl: "https://ai-gateway.vercel.sh",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.2,
				output: 4,
				cacheRead: 0.24,
				cacheWrite: 0,
			},
			contextWindow: 200000,
			maxTokens: 128000,
		} satisfies Model<"anthropic-messages">,
	},
	"xai": {
		"grok-4.20-0309-non-reasoning": {
			id: "grok-4.20-0309-non-reasoning",
			name: "Grok 4.20 (Non-Reasoning)",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: false,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 30000,
		} satisfies Model<"openai-completions">,
		"grok-4.20-0309-reasoning": {
			id: "grok-4.20-0309-reasoning",
			name: "Grok 4.20 (Reasoning)",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 30000,
		} satisfies Model<"openai-completions">,
		"grok-4.3": {
			id: "grok-4.3",
			name: "Grok 4.3",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1.25,
				output: 2.5,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 1000000,
			maxTokens: 30000,
		} satisfies Model<"openai-completions">,
		"grok-4.5": {
			id: "grok-4.5",
			name: "Grok 4.5",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.3,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-completions">,
		"grok-4.6": {
			id: "grok-4.6",
			name: "Grok 4.6",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-completions">,
		"grok-4.7": {
			id: "grok-4.7",
			name: "Grok 4.7",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 2,
				output: 6,
				cacheRead: 0.5,
				cacheWrite: 0,
			},
			contextWindow: 500000,
			maxTokens: 500000,
		} satisfies Model<"openai-completions">,
		"grok-build-0.1": {
			id: "grok-build-0.1",
			name: "Grok Build 0.1",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: true,
			input: ["text", "image"],
			cost: {
				input: 1,
				output: 2,
				cacheRead: 0.2,
				cacheWrite: 0,
			},
			contextWindow: 256000,
			maxTokens: 256000,
		} satisfies Model<"openai-completions">,
		"grok-code-fast-1": {
			id: "grok-code-fast-1",
			name: "Grok Code Fast 1",
			api: "openai-completions",
			provider: "xai",
			baseUrl: "https://api.x.ai/v1",
			reasoning: false,
			input: ["text"],
			cost: {
				input: 0.2,
				output: 1.5,
				cacheRead: 0.02,
				cacheWrite: 0,
			},
			contextWindow: 32768,
			maxTokens: 8192,
		} satisfies Model<"openai-completions">,
	},
} as const;
